(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeeroul-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-jr-builder]').forEach(function (root) {
      var sizes = Array.prototype.slice.call(root.querySelectorAll('[data-jr-size]'));
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-jr-item]'));
      var countEl = root.querySelector('[data-jr-count]');
      var remainEl = root.querySelector('[data-jr-remaining]');
      var progressEl = root.querySelector('[data-jr-progress]');
      var summaryEl = root.querySelector('[data-jr-summary]');
      var alertEl = root.querySelector('[data-jr-alert]');
      var submitEl = root.querySelector('[data-jr-submit]');
      if (!sizes.length || !rows.length || !submitEl) return;

      var active = sizes.filter(function (s) { return !s.disabled; })[0] || sizes[0];
      var target = 0;
      var busy = false;
      var picks = {};

      rows.forEach(function (row) { picks[row.dataset.handle] = 0; });

      /* A flavour card's "Built Mix" links here as ?flavour=<handle>, so the
         box starts with one of that flavour. Kept as a seed because changing
         the pack size empties the box, and the visitor still came for it. */
      var seed = null;
      try { seed = new URLSearchParams(window.location.search).get('flavour'); } catch (e) { seed = null; }
      if (!seed || !picks.hasOwnProperty(seed)) seed = null;

      var total = function () {
        return rows.reduce(function (sum, row) { return sum + picks[row.dataset.handle]; }, 0);
      };

      var summary = function () {
        return rows
          .filter(function (row) { return picks[row.dataset.handle] > 0; })
          .map(function (row) { return row.dataset.title + ' x ' + picks[row.dataset.handle]; })
          .join(', ');
      };

      var setAlert = function (text) { if (alertEl) alertEl.textContent = text || ''; };

      var render = function () {
        var n = total();
        var left = Math.max(target - n, 0);

        countEl.textContent = n + '/' + target;
        remainEl.textContent = left > 0 ? left + ' to go' : 'Box is full';
        progressEl.style.width = (target ? Math.min((n / target) * 100, 100) : 0) + '%';
        summaryEl.textContent = n > 0
          ? summary()
          : 'Pick your flavours, or use a quick pick above.';

        submitEl.disabled = busy || n !== target;
        submitEl.textContent = busy
          ? 'Adding…'
          : left > 0
            ? left + ' more to go'
            : (root.dataset.orderMode === 'whatsapp' ? 'Send this mix' : 'Add box · ' + active.dataset.price);

        rows.forEach(function (row) {
          var value = picks[row.dataset.handle];
          row.querySelector('[data-jr-out]').textContent = value;
          row.classList.toggle('is-chosen', value > 0);
          row.querySelector('[data-jr-minus]').disabled = busy || value === 0;
          row.querySelector('[data-jr-plus]').disabled = busy || n >= target;
        });

        sizes.forEach(function (size) { size.classList.toggle('is-active', size === active); });
        root.querySelectorAll('[data-jr-preset]').forEach(function (b) { b.disabled = busy; });
      };

      var setSize = function (button) {
        active = button;
        target = parseInt(button.dataset.count, 10) || 0;
        rows.forEach(function (row) { picks[row.dataset.handle] = 0; });
        if (seed && target > 0) picks[seed] = 1;
        setAlert('');
        render();
      };

      sizes.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!button.disabled) setSize(button);
        });
      });

      rows.forEach(function (row) {
        row.querySelector('[data-jr-plus]').addEventListener('click', function () {
          if (total() < target) { picks[row.dataset.handle] += 1; setAlert(''); render(); }
        });
        row.querySelector('[data-jr-minus]').addEventListener('click', function () {
          if (picks[row.dataset.handle] > 0) { picks[row.dataset.handle] -= 1; setAlert(''); render(); }
        });
      });

      root.querySelectorAll('[data-jr-preset]').forEach(function (button) {
        button.addEventListener('click', function () {
          var wanted = (button.dataset.handles || '')
            .split(',')
            .map(function (h) { return h.trim(); })
            .filter(function (h) { return h && picks.hasOwnProperty(h); });

          /* A preset naming handles that are not in the collection would
             otherwise silently produce an empty box. */
          if (!wanted.length) {
            setAlert('That quick pick refers to flavours this collection does not have.');
            return;
          }

          rows.forEach(function (row) { picks[row.dataset.handle] = 0; });
          for (var i = 0; i < target; i++) picks[wanted[i % wanted.length]] += 1;
          setAlert('');
          render();
        });
      });

      var clear = root.querySelector('[data-jr-clear]');
      if (clear) {
        clear.addEventListener('click', function () {
          rows.forEach(function (row) { picks[row.dataset.handle] = 0; });
          setAlert('');
          render();
        });
      }

      submitEl.addEventListener('click', function () {
        if (busy || total() !== target) return;
        var mix = summary();

        if (root.dataset.orderMode === 'whatsapp') {
          var text = 'Hi Jeeroul, I would like ' + active.querySelector('strong').textContent.trim() +
            ' (' + active.dataset.price + '). Flavour mix: ' + mix + '.';
          var url;
          try {
            url = new URL(root.dataset.waUrl, window.location.origin);
          } catch (e) {
            url = new URL('/pages/contact', window.location.origin);
          }
          if (/wa\.me|whatsapp\.com/.test(url.hostname)) {
            url.searchParams.set('text', text);
          } else {
            url = new URL('/pages/contact', window.location.origin);
            url.searchParams.set('mix', text);
          }
          window.location.href = url.toString();
          return;
        }

        busy = true;
        setAlert('');
        render();

        fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(active.dataset.variant),
              quantity: 1,
              /* Fulfilment reads this property name. Do not rename it. */
              properties: { 'Flavour mix': mix }
            }]
          })
        })
          .then(function (res) {
            if (res.ok) { window.location.href = root.dataset.cartUrl; return null; }
            return res.json().then(function (body) {
              throw new Error(body.description || body.message || 'Could not add that box to the cart.');
            });
          })
          .catch(function (err) {
            busy = false;
            setAlert(err.message);
            render();
          });
      });

      setSize(active);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeeroul-pdp"] && !Shopify.designMode) return;
  try {
    
  /* PDP behaviour. Progressive enhancement only: with this file absent the
     form still posts to /cart/add and the page still sells. */
  (function () {
    document.querySelectorAll('[data-jr-pdp]').forEach(function (root) {
      var payload = root.querySelector('[data-jr-variants]');
      if (!payload) return;

      var variants = [];
      var prices = {};
      try {
        variants = JSON.parse(payload.textContent) || [];
        var priceNode = root.querySelector('[data-jr-prices]');
        if (priceNode) prices = JSON.parse(priceNode.textContent) || {};
      } catch (e) {
        return; /* leave the no-JS form exactly as rendered */
      }

      var priceEl = root.querySelector('[data-jr-price]');
      var compareEl = root.querySelector('[data-jr-compare]');
      var unitEl = root.querySelector('[data-jr-unit]');
      var idInput = root.querySelector('[data-jr-variant-id]');
      var addBtn = root.querySelector('[data-jr-add]');
      var addLabel = root.querySelector('[data-jr-add-label]');
      var sticky = document.querySelector('[data-jr-sticky]');
      var stickyPrice = document.querySelector('[data-jr-sticky-price]');
      var addText = addLabel ? addLabel.textContent.trim() : 'Add to cart';

      /* Formatted by Liquid; JS never builds a price string of its own. */
      var priced = function (variant) { return prices[String(variant.id)] || {}; };

      var chosen = function () {
        var picked = [];
        root.querySelectorAll('[data-jr-option-index]').forEach(function (set) {
          var hit = set.querySelector('[data-jr-option]:checked');
          picked.push(hit ? hit.value : null);
        });
        return picked;
      };

      var find = function (picked) {
        if (!picked.length) return variants[0];
        for (var i = 0; i < variants.length; i++) {
          var match = true;
          for (var j = 0; j < picked.length; j++) {
            if (variants[i].options[j] !== picked[j]) { match = false; break; }
          }
          if (match) return variants[i];
        }
        return null;
      };

      var render = function () {
        var variant = find(chosen());
        if (!variant) return;
        var money = priced(variant);

        if (idInput) idInput.value = variant.id;
        if (priceEl && money.price) priceEl.textContent = money.price;
        if (stickyPrice && money.price) stickyPrice.textContent = money.price;

        if (compareEl) {
          if (money.compare) {
            compareEl.textContent = money.compare;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        /* Per-pack figure, computed and formatted by Liquid — never typed. */
        if (unitEl) {
          unitEl.textContent = money.unit || '';
          unitEl.hidden = !money.unit;
        }

        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (addLabel) addLabel.textContent = variant.available ? addText : 'Sold out';
        }

        /* Keep the address bar honest so a shared link opens the same variant. */
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      };

      root.querySelectorAll('[data-jr-option]').forEach(function (input) {
        input.addEventListener('change', render);
      });

      /* Thumbnails.

         THE MAIN IMAGE WAS NEVER FOUND, so every tap on a thumbnail did
         nothing — reported as "点不到，换不到照片". This looked for a
         data-jr-main-image attribute passed to image_tag as a named argument,
         and that attribute never reaches the HTML: not with an empty value,
         and — checked live after "fixing" that — not with a value either.
         A hyphenated data- key does not survive as an image_tag argument.
         mainImg was null, and the handler returned on its first line without
         a sound.

         So the image is found by STRUCTURE, which does not depend on a filter
         passing anything through. The attribute lookup stays first only
         because it costs nothing if a future Shopify release starts
         honouring it. */
      var mainImg = root.querySelector('[data-jr-main-image]') || root.querySelector('.jr-pdp__main img');
      root.querySelectorAll('[data-jr-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!mainImg) return;
          mainImg.src = thumb.dataset.full;
          mainImg.removeAttribute('srcset');
          root.querySelectorAll('[data-jr-thumb]').forEach(function (other) {
            other.removeAttribute('aria-current');
          });
          thumb.setAttribute('aria-current', 'true');
        });
      });

      /* Sticky bar: show it once the real buy button has scrolled away. */
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        sticky.hidden = false;
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { rootMargin: '0px 0px -80px 0px' }).observe(addBtn);

        var stickyAdd = document.querySelector('[data-jr-sticky-add]');
        if (stickyAdd) stickyAdd.addEventListener('click', function () { addBtn.click(); });
      }

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeeroul-replica"]) return;
  try {
    
  /* The box builder, driven by the nodes the designer drew.
   *
   * The markup is the design's — absolutely positioned glyphs — so this only
   * reads and writes their text; it never moves anything. The cart line and
   * its "Flavour mix" property match jeeroul-builder.liquid EXACTLY, because
   * fulfilment reads that property and an order must not depend on which of
   * the two pages it came from. */
  (function () {
    var root = document.querySelector('.jr-rep');
    if (!root) return;

    var titles = {};
    var raw = root.parentNode.querySelector('[data-jr-flavours]') || document.querySelector('[data-jr-flavours]');
    if (raw) {
      try {
        JSON.parse(raw.textContent).forEach(function (f) { titles[f.handle] = f.title; });
      } catch (e) { /* titles fall back to the handle */ }
    }

    /* One canvas is display:none at any width; both carry the same controls,
       so state is shared and every visible control is re-rendered. */
    var picks = {};
    var target = 12;
    var variant = null;
    var busy = false;

    var all = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var total = function () {
      var n = 0;
      for (var k in picks) if (Object.prototype.hasOwnProperty.call(picks, k)) n += picks[k];
      return n;
    };

    var mix = function () {
      var out = [];
      all('[data-jr-step]').forEach(function (b) {
        var h = b.dataset.jrFlavour;
        if (out.indexOf(h) === -1) out.push(h);
      });
      return out
        .filter(function (h) { return picks[h] > 0; })
        .map(function (h) { return (titles[h] || h) + ' x ' + picks[h]; })
        .join(', ');
    };

    /* Errors get their OWN box, at a fixed readable size, placed under the
       button that failed.

       They used to be written into [data-jr-status] — the design's "12-Pack
       mix ready" line, which sits directly over the counter at 10px and is
       centred. A one-line status fits there; a sentence from the server does
       not, and the store's delivery gate returned one about a postcode not
       matching its state, which landed straight across the "12 / 12". The
       page looked broken when nothing was: the add had simply been refused. */
    var showError = function (msg) {
      all('[data-jr-add]').forEach(function (btn) {
        var canvas = btn.closest('.jr-rep__canvas');
        if (!canvas) return;
        var box = canvas.querySelector('.jr-rep__err');
        if (!box) {
          box = document.createElement('div');
          box.className = 'jr-rep__err';
          box.setAttribute('role', 'alert');
          canvas.appendChild(box);
        }
        box.textContent = msg;
        box.style.left = btn.offsetLeft + 'px';
        box.style.top = (btn.offsetTop + btn.offsetHeight + 12) + 'px';
        box.style.minWidth = btn.offsetWidth + 'px';
        box.hidden = false;
      });
    };
    var clearError = function () {
      Array.prototype.slice.call(root.querySelectorAll('.jr-rep__err')).forEach(function (e) { e.hidden = true; });
    };

    var render = function () {
      all('[data-jr-count]').forEach(function (el) {
        el.textContent = String(picks[el.dataset.jrCount] || 0);
      });
      var n = total();
      all('[data-jr-total]').forEach(function (el) { el.textContent = n + ' / ' + target; });
      all('[data-jr-status]').forEach(function (el) {
        el.textContent = n === target
          ? target + '-Pack mix ready'
          : (n > target ? (n - target) + ' too many' : (target - n) + ' more to go');
      });
      all('[data-jr-add]').forEach(function (el) {
        el.disabled = busy || n !== target;
        el.style.opacity = el.disabled ? '0.45' : '';
        el.style.cursor = el.disabled ? 'not-allowed' : 'pointer';
      });
      all('[data-jr-pack]').forEach(function (el) {
        el.setAttribute('aria-pressed', String(Number(el.dataset.jrPack) === target));
      });
      all('[data-jr-step]').forEach(function (el) {
        var h = el.dataset.jrFlavour;
        el.disabled = Number(el.dataset.jrStep) < 0 && !picks[h];
        el.style.opacity = el.disabled ? '0.35' : '';
      });
    };

    all('[data-jr-step]').forEach(function (b) {
      picks[b.dataset.jrFlavour] = 0;
      b.addEventListener('click', function () {
        var h = b.dataset.jrFlavour;
        var next = (picks[h] || 0) + Number(b.dataset.jrStep);
        if (next < 0) return;
        if (Number(b.dataset.jrStep) > 0 && total() >= target) return;   /* the box is full */
        picks[h] = next;
        clearError();
        render();
      });
    });

    all('[data-jr-pack]').forEach(function (b, i) {
      if (i === 0) { target = Number(b.dataset.jrPack); variant = b.dataset.jrVariant; }
      b.addEventListener('click', function () {
        target = Number(b.dataset.jrPack);
        variant = b.dataset.jrVariant;
        /* A smaller box cannot hold the bigger box's picks. */
        if (total() > target) for (var k in picks) picks[k] = 0;
        clearError();
        render();
      });
    });

    all('[data-jr-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (busy || total() !== target || !variant) return;
        busy = true;
        render();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(variant),
              quantity: 1,
              /* Fulfilment reads this property name. Do not rename it. */
              properties: { 'Flavour mix': mix() }
            }]
          })
        })
          .then(function (res) {
            if (res.ok) { window.location.href = '/cart'; return null; }
            return res.json().then(function (body) {
              throw new Error(body.description || body.message || 'Could not add that box.');
            });
          })
          .catch(function (err) {
            busy = false;
            render();
            showError(err.message);
          });
      });
    });

    /* The hamburger. The mobile frame draws it and nothing else — no nav
       text — so without this the phone has no navigation at all. It opens the
       same links the desktop header shows, which are the same links the
       footer lists, so nothing here is invented. */
    var menuItems = [];
    var menuRaw = document.querySelector('[data-jr-menu-items]');
    if (menuRaw) { try { menuItems = JSON.parse(menuRaw.textContent); } catch (e) { menuItems = []; } }

    all('[data-jr-menu]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var canvas = btn.closest('.jr-rep__canvas');
        var panel = canvas.querySelector('.jr-rep__menu');
        if (!panel) {
          panel = document.createElement('nav');
          panel.className = 'jr-rep__menu';
          panel.setAttribute('aria-label', 'Menu');
          menuItems.forEach(function (it) {
            var a = document.createElement('a');
            a.href = it.href;
            a.textContent = it.label;
            panel.appendChild(a);
          });
          /* Created hidden, so the FIRST click opens it. Without this the
             toggle reads "not hidden" on a brand-new panel and closes it,
             which looks exactly like a dead hamburger. */
          panel.setAttribute('hidden', '');
          canvas.appendChild(panel);
        }
        var open = panel.hasAttribute('hidden');
        if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', String(open));
        panel.style.top = (btn.offsetTop + btn.offsetHeight + 10) + 'px';
      });
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-jeeroul-b-en"]) return;
  try {
    
(() => {
  'use strict';
  const configNode = document.getElementById('jrb-config');
  if (!configNode || configNode.dataset.initialized === 'true') return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  // Liquid's translation filter HTML-escapes text before JSON serialization.
  const decodeText = value => String(value ?? '').replace(/&(amp|lt|gt|quot|#39|#x27);/g, (match, entity) => ({amp:'&', lt:'<', gt:'>', quot:'"', '#39':"'", '#x27':"'"}[entity]));
  const flavours = Array.isArray(config.flavours) ? config.flavours.map(flavour => ({...flavour, zh:decodeText(flavour.zh), en:decodeText(flavour.en), short:decodeText(flavour.short), description:decodeText(flavour.description)})) : [];
  const packages = config.packages || {};
  if (!flavours.length || !packages[12] || !packages[20]) return;
  configNode.dataset.initialized = 'true';
  const $ = selector => document.querySelector(selector);
  const $$ = selector => [...document.querySelectorAll(selector)];
  const strings = config.strings || {};
  const t = (key, values = {}) => decodeText(strings[key === 'pack_quantity' && values.count === 1 ? 'pack_quantity_one' : key] || strings[key] || key).replace(/\{(\w+)\}/g, (match, name) => values[name] == null ? match : String(values[name]));
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[character]));
  const arrow = '<svg aria-hidden="true"><use href="#arrow"/></svg>';
  const mobileBuildLabel = $('#mobile-box')?.textContent.trim() || '';
  // Change only the alternate view; retain advertising parameters and page position.
  const updateLanguageLinks = () => $$('[data-language-view]').forEach(link => {
    const url = new URL(location.href);
    url.searchParams.set('view', link.dataset.languageView);
    link.href = url.href;
  });
  updateLanguageLinks();
  window.addEventListener('hashchange', updateLanguageLinks);

  const storageKey = `jeeroul:${config.landingId || 'lp-jeeroul-b'}:${config.product?.id || ''}`;
  const readStored = suffix => { try { return JSON.parse(sessionStorage.getItem(`${storageKey}:${suffix}`)); } catch { return null; } };
  const saveStored = (suffix, value) => { try { sessionStorage.setItem(`${storageKey}:${suffix}`, JSON.stringify(value)); } catch {} };
  const safeLocal = (value, fallback) => { try { const url = new URL(value || fallback, location.origin); return url.origin === location.origin ? url.pathname + url.search : fallback; } catch { return fallback; } };
  let rootUrl = safeLocal(window.Shopify?.routes?.root || config.rootUrl, '/');
  if (!rootUrl.endsWith('/')) rootUrl += '/';
  const cartUrl = safeLocal(config.cartUrl, `${rootUrl}cart`);
  const checkoutUrl = safeLocal(config.checkoutUrl, `${rootUrl}checkout`);
  const state = {size:12, quantities:Object.fromEntries(flavours.map(flavour => [flavour.id, 0])), detail:null};
  const saved = readStored('selection');
  if (saved && [12,20].includes(saved.size)) {
    state.size = saved.size;
    flavours.forEach(flavour => {
      const value = saved.quantities?.[flavour.id];
      state.quantities[flavour.id] = Number.isInteger(value) && value >= 0 && value <= 20 ? value : 0;
    });
  }
  let attempt = readStored('attempt');
  if (!attempt || !/^[a-zA-Z0-9_-]{8,100}$/.test(attempt.id || '') || !['adding','uncertain','added'].includes(attempt.status)) attempt = null;
  let busy = false;
  let navigating = false;
  let checkoutPromise = null;
  let stage = '';
  let toastTimer;
  let pendingMix = null;
  const total = () => flavours.reduce((sum, flavour) => sum + state.quantities[flavour.id], 0);
  const selectedPackage = () => packages[state.size];
  const purchasable = pack => pack && pack.available === true && /^\d+$/.test(String(pack.id)) && Number.isFinite(Number(pack.price)) && Number(pack.price) > 0;
  const signature = () => JSON.stringify([String(selectedPackage().id), state.size, flavours.map(flavour => state.quantities[flavour.id])]);
  const money = cents => {
    const value = Number(cents) / 100;
    if (config.currency === 'MYR') return `RM${value.toLocaleString(config.locale || 'zh-CN', {minimumFractionDigits:Number.isInteger(value) ? 0 : 2, maximumFractionDigits:2})}`;
    return new Intl.NumberFormat(config.locale || 'zh-CN', {style:'currency', currency:config.currency || 'MYR'}).format(value);
  };
  const mixText = () => flavours.filter(flavour => state.quantities[flavour.id] > 0).map(flavour => `${flavour.fulfilmentName || flavour.en} x ${state.quantities[flavour.id]}`).join(', ');
  const persistSelection = () => saveStored('selection', {size:state.size, quantities:state.quantities});
  const persistAttempt = () => saveStored('attempt', attempt);
  const toast = text => {
    const element = $('#toast');
    if (!element) return;
    element.textContent = text;
    element.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => element.classList.remove('show'), 3500);
  };
  const showError = message => {
    const element = $('#checkout-error');
    if (!element) return;
    element.textContent = message || '';
    element.hidden = !message;
    if (message) { element.setAttribute('tabindex', '-1'); element.focus({preventScroll:true}); }
  };
  const flavourGrid = $('#flavour-grid');
  const mixList = $('#mix-list');
  if (flavourGrid && !flavourGrid.querySelector('.flavour-card')) flavourGrid.innerHTML = flavours.map(flavour => `<article class="flavour-card"><button type="button" class="flavour-image" data-detail="${escape(flavour.id)}" aria-label="${escape(t('photo_label', {name:flavour.zh, energy:flavour.energy}))}"><img src="${escape(flavour.image)}" width="1080" height="1350" loading="lazy" alt="${escape(t('photo_alt', {english:flavour.en, name:flavour.zh, energy:flavour.energy}))}"><span class="zoom-label" aria-hidden="true">+</span></button><div class="flavour-card-bottom"><div><h3>${escape(flavour.zh)}</h3><p class="flavour-card-en" lang="en">${escape(flavour.en)}</p><p>${escape(flavour.short)}</p></div><button type="button" class="flavour-add" data-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></article>`).join('');
  if (mixList && !mixList.querySelector('.mix-row')) mixList.innerHTML = flavours.map(flavour => `<div class="mix-row"><button type="button" class="mix-thumb" data-detail="${escape(flavour.id)}" aria-label="${escape(t('detail_label', {name:flavour.zh}))}"><img src="${escape(flavour.image)}" alt="${escape(flavour.zh)}" width="1080" height="1350" loading="lazy"></button><div class="mix-name"><h3>${escape(flavour.zh)}</h3><p>${escape(flavour.en)}</p></div><div class="stepper"><button type="button" data-minus="${escape(flavour.id)}" aria-label="${escape(t('minus_label', {name:flavour.zh}))}">−</button><output data-qty="${escape(flavour.id)}" aria-label="${escape(t('quantity_label', {name:flavour.zh}))}">0</output><button type="button" data-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></div>`).join('');
  $$('[data-package-price]').forEach(element => { const pack = packages[element.dataset.packagePrice]; if (pack) element.textContent = money(pack.price); });
  $$('[data-package-per-pack]').forEach(element => { const size = Number(element.dataset.packagePerPack); if (packages[size]) element.textContent = t('per_pack', {price:money(packages[size].price / size)}); });
  const availablePackages = [12,20].filter(size => purchasable(packages[size]));
  if (availablePackages.length) $$('[data-from-price]').forEach(element => { element.textContent = money(Math.min(...availablePackages.map(size => packages[size].price / size))); });
  $$('[data-view-cart], #view-cart').forEach(element => { element.href = cartUrl; });
  const updateWhatsApp = () => {
    if (!config.whatsappUrl) return;
    try {
      const url = new URL(config.whatsappUrl);
      if (!['wa.me','api.whatsapp.com','web.whatsapp.com'].includes(url.hostname) || url.protocol !== 'https:') return;
      url.searchParams.set('text', t('whatsapp_message', {size:state.size, mix:mixText() || t('no_mix')}));
      $$('#contact-whatsapp, [data-contact-whatsapp]').forEach(element => { element.href = url.href; });
    } catch {}
  };
  let pwpPackageSignature = '';
  const publishPwpPackage = (force = false) => {
    const detail = {size:state.size,price:selectedPackage().price,currency:config.currency || 'MYR'};
    const next = JSON.stringify(detail);
    if (force || next !== pwpPackageSignature) {
      pwpPackageSignature = next;
      document.dispatchEvent(new CustomEvent('jeeroul:package-change',{detail,bubbles:true}));
    }
  };
  window.addEventListener('jeeroul:pwp-ready', () => publishPwpPackage(true));
  const render = () => {
    window.JeeroulPwp?.setBusy?.(busy);
    publishPwpPackage();
    const count = total();
    const remaining = state.size - count;
    const available = purchasable(selectedPackage());
    $$('[data-count]').forEach(element => { element.textContent = count; });
    $$('[data-size-label]').forEach(element => { element.textContent = state.size; });
    $$('[data-price]').forEach(element => { element.textContent = money(selectedPackage().price); });
    $$('[data-size]').forEach(element => {
      const size = Number(element.dataset.size);
      element.setAttribute('aria-pressed', String(size === state.size));
      element.disabled = busy;
      element.classList.toggle('is-unavailable', !purchasable(packages[size]));
      const status = element.querySelector('[data-package-status]');
      if (status) status.textContent = purchasable(packages[size]) ? '' : t('sold_out');
    });
    $$('[data-qty]').forEach(element => { element.textContent = state.quantities[element.dataset.qty]; });
    $$('[data-minus]').forEach(element => { element.disabled = busy || state.quantities[element.dataset.minus] === 0; });
    $$('[data-add]').forEach(element => { element.disabled = busy || remaining <= 0; });
    ['#even-mix','#clear-mix','#confirm-remix'].forEach(selector => { if ($(selector)) $(selector).disabled = busy; });
    const progress = $('#mix-progress');
    if (progress) { progress.max = state.size; progress.value = Math.min(count, state.size); }
    if ($('[data-percent]')) $('[data-percent]').textContent = `${Math.round(count / state.size * 100)}%`;
    const status = $('#mix-status');
    if (status) { status.textContent = remaining > 0 ? t('need_more', {count:remaining}) : remaining < 0 ? t('remove_extra', {count:-remaining}) : t('mix_complete'); status.style.color = remaining < 0 ? '#a64224' : ''; }
    const review = $('#review-box');
    if (review) {
      review.disabled = busy || remaining !== 0 || !available;
      review.innerHTML = escape(!available ? t('sold_out') : remaining > 0 ? t('need_more_short', {count:remaining}) : remaining < 0 ? t('remove_extra_short', {count:-remaining}) : t('review_mix')) + arrow;
    }
    const mobileReview = $('#mobile-box');
    if (mobileReview) {
      const ready = remaining === 0 && available;
      mobileReview.disabled = busy;
      mobileReview.innerHTML = escape(ready ? t('review_mix') : mobileBuildLabel) + arrow;
      mobileReview.setAttribute('aria-controls', ready ? 'box-dialog' : 'build');
      if (ready) mobileReview.setAttribute('aria-haspopup', 'dialog');
      else mobileReview.removeAttribute('aria-haspopup');
    }
    const checkout = $('#checkout-box');
    if (checkout) {
      const matchesAttempt = attempt?.signature === signature();
      const label = busy ? t(stage || 'adding') : matchesAttempt && attempt.status === 'added' ? t('continue_checkout') : attempt && ['adding','uncertain'].includes(attempt.status) ? t('check_cart') : t('checkout');
      checkout.textContent = !available ? t('sold_out') : label;
      checkout.disabled = busy || remaining !== 0 || !available;
      checkout.setAttribute('aria-busy', String(busy));
    }
    const dialogAdd = $('#dialog-add');
    if (dialogAdd) dialogAdd.disabled = busy || remaining <= 0;
    const feedback = $('#dialog-feedback');
    if (feedback) feedback.textContent = remaining < 0 ? t('box_over', {total:count, count:-remaining}) : remaining === 0 ? t('dialog_full') : '';
    updateWhatsApp();
    persistSelection();
  };
  const add = (id, notify = false) => {
    const flavour = flavours.find(item => item.id === id);
    if (busy || !flavour) return false;
    if (total() >= state.size) { toast(total() > state.size ? t('box_over', {total:total(), count:total()-state.size}) : t('box_full', {size:state.size})); return false; }
    state.quantities[id] += 1;
    showError('');
    render();
    if (notify) toast(t('added_flavour', {name:flavour.zh, total:total(), size:state.size}));
    return true;
  };
  const showFlavour = id => {
    const flavour = flavours.find(item => item.id === id);
    const dialog = $('#flavour-dialog');
    if (!flavour || !dialog) return;
    state.detail = id;
    $('#flavour-dialog-title').textContent = flavour.zh;
    $('#flavour-dialog-en').textContent = flavour.en;
    $('#flavour-dialog-description').textContent = flavour.description;
    $('#flavour-dialog-energy').textContent = flavour.energy;
    $('#flavour-dialog-image').src = flavour.image;
    $('#flavour-dialog-image').alt = t('photo_alt', {english:flavour.en, name:flavour.zh, energy:flavour.energy});
    render();
    dialog.showModal();
    dialog.scrollTop = 0;
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const detail = event.target.closest('[data-detail]');
    const plus = event.target.closest('[data-add]');
    const minus = event.target.closest('[data-minus]');
    const size = event.target.closest('[data-size]');
    const close = event.target.closest('[data-close]');
    if (detail) showFlavour(detail.dataset.detail);
    if (plus) add(plus.dataset.add, !plus.closest('.stepper'));
    if (minus && !busy && Object.hasOwn(state.quantities, minus.dataset.minus)) { state.quantities[minus.dataset.minus] = Math.max(0, state.quantities[minus.dataset.minus] - 1); showError(''); render(); }
    if (size && !busy && [12,20].includes(Number(size.dataset.size))) { state.size = Number(size.dataset.size); showError(''); render(); }
    if (close) close.closest('dialog')?.close();
  });
  const calculateEvenMix = () => {
    const base = Math.floor(state.size / flavours.length);
    const extra = state.size % flavours.length;
    return {size:state.size, quantities:Object.fromEntries(flavours.map((flavour, index) => [flavour.id, base + (index < extra ? 1 : 0)]))};
  };
  const applyEvenMix = mix => {
    if (busy || !mix || mix.size !== state.size) return;
    flavours.forEach(flavour => { state.quantities[flavour.id] = mix.quantities[flavour.id]; });
    showError(''); render(); toast(t('even_mix', {size:state.size}));
  };
  $('#pack-photo-open')?.addEventListener('click', () => { if (!busy) $('#pack-photo-dialog')?.showModal(); });
  $('#even-mix')?.addEventListener('click', () => {
    if (busy) return;
    const mix = calculateEvenMix();
    if (total() === 0) { applyEvenMix(mix); return; }
    const dialog = $('#mix-replace-dialog');
    if (!dialog) return;
    pendingMix = mix;
    $('#mix-replace-package').textContent = t('package_summary', {size:mix.size});
    $('#mix-replace-items').innerHTML = flavours.map(flavour => `<li><span>${escape(flavour.zh)}</span><strong>${escape(t('pack_quantity', {count:mix.quantities[flavour.id]}))}</strong></li>`).join('');
    dialog.showModal();
  });
  $('#confirm-remix')?.addEventListener('click', () => {
    if (busy || !pendingMix) return;
    const mix = pendingMix;
    pendingMix = null;
    $('#mix-replace-dialog').close();
    applyEvenMix(mix);
  });
  $('#mix-replace-dialog')?.addEventListener('close', () => { pendingMix = null; });
  $('#clear-mix')?.addEventListener('click', () => { if (!busy) { flavours.forEach(flavour => { state.quantities[flavour.id] = 0; }); showError(''); render(); } });
  $('#dialog-add')?.addEventListener('click', () => {
    if (!add(state.detail)) return;
    $('#flavour-dialog').close();
    $$('[data-minus]').find(element => element.dataset.minus === state.detail)?.focus({preventScroll:true});
    $('#build')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    toast(t('continue_mix'));
  });
  const showBox = () => {
    if (busy || total() !== state.size || !purchasable(selectedPackage())) return;
    $('#box-dialog-package').textContent = t('package_summary', {size:state.size});
    $('#box-dialog-items').innerHTML = flavours.filter(flavour => state.quantities[flavour.id] > 0).map(flavour => `<li><span>${escape(flavour.zh)}</span><strong>${escape(t('pack_quantity', {count:state.quantities[flavour.id]}))}</strong></li>`).join('');
    showError(''); render(); $('#box-dialog').showModal();
  };
  $('#review-box')?.addEventListener('click', showBox);
  $('#mobile-box')?.addEventListener('click', () => {
    if (busy) return;
    if (total() === state.size && purchasable(selectedPackage())) showBox();
    else $('#build')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  $$('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }));
  const request = async (path, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(`${rootUrl}${path}`, {...options, credentials:'same-origin', cache:'no-store', signal:controller.signal, headers:{Accept:'application/json', ...(options.headers || {})}});
      let data;
      try { data = await response.json(); } catch { throw new Error('invalid_response'); }
      return {response, data};
    } finally { clearTimeout(timer); }
  };
  const reconcile = async pending => {
    stage = 'checking'; render();
    const {response, data} = await request('cart.js');
    if (!response.ok || !Array.isArray(data.items)) throw new Error('cart_unavailable');
    $$('[data-cart-count]').forEach(element => { element.textContent = data.item_count; });
    const items = data.items.filter(item => item.properties?._jrb_attempt === pending.id);
    if (!items.length) return 'missing';
    if (items.length !== 1 || String(items[0].variant_id || items[0].id) !== String(pending.variantId) || items[0].quantity !== 1 || items[0].properties?.['Flavour mix'] !== pending.mix) return 'changed';
    return 'found';
  };
  const makeAttempt = () => {
    const random = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now().toString(36)}-${Array.from(crypto.getRandomValues(new Uint32Array(3))).map(value => value.toString(36)).join('-')}`;
    return {id:random, signature:signature(), variantId:String(selectedPackage().id), mix:mixText(), status:'adding', createdAt:Date.now()};
  };
  const makeProperties = pending => {
    const properties = {'Flavour mix':pending.mix, _landing_page:config.landingId || 'lp-jeeroul-b', _jrb_attempt:pending.id};
    const params = new URLSearchParams(location.search);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key => {
      const value = params.get(key);
      if (value) properties[`_${key}`] = value.replace(/[\u0000-\u001F\u007F]/g, '').slice(0, 150);
    });
    return properties;
  };
  const goCheckout = () => {
    stage = 'redirecting'; navigating = true; render();
    const form = document.createElement('form');
    form.method = 'post'; form.action = cartUrl; form.hidden = true;
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = 'checkout'; input.value = '1';
    form.append(input); document.body.append(form);
    try { HTMLFormElement.prototype.submit.call(form); } catch { location.assign(checkoutUrl); }
  };
  const ensureMainBox = async () => {
    showError('');
    if (total() !== state.size) { showError(t('invalid_mix', {size:state.size})); return; }
    if (!purchasable(selectedPackage())) { showError(t('unavailable')); return; }
    if (attempt) {
      let result;
      try { result = await reconcile(attempt); } catch { showError(t('uncertain')); return; }
      if (result === 'changed') { showError(t('changed_cart')); return; }
      if (result === 'found') {
        attempt.status = 'added'; persistAttempt();
        if (attempt.signature === signature()) { return true; }
      } else if (attempt.status !== 'added') {
        attempt.status = 'uncertain'; persistAttempt(); showError(t('uncertain_not_found')); return;
      }
    }
    attempt = makeAttempt(); persistAttempt();
    stage = 'adding'; render();
    try {
      const {response, data} = await request('cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:attempt.variantId, quantity:1, properties:makeProperties(attempt)}]})});
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) { attempt = null; persistAttempt(); showError(t('add_failed')); return; }
        throw new Error('uncertain_add');
      }
      const items = Array.isArray(data.items) ? data.items : [data];
      const added = items.find(item => item.properties?._jrb_attempt === attempt.id);
      if (!added || String(added.variant_id || added.id) !== attempt.variantId || added.quantity !== 1 || added.properties?.['Flavour mix'] !== attempt.mix) throw new Error('unconfirmed_add');
      attempt.status = 'added'; persistAttempt(); return true;
    } catch {
      attempt.status = 'uncertain'; persistAttempt();
      try {
        const result = await reconcile(attempt);
        if (result === 'found') { attempt.status = 'added'; persistAttempt(); return true; }
        showError(t(result === 'changed' ? 'changed_cart' : 'uncertain'));
      } catch { showError(t('uncertain')); }
    }
  };
  // The main-box attempt remains independent from the optional PWP transaction.
  const performCheckout = async () => {
    const pwp = window.JeeroulPwp;
    let pwpConfig = pwp?.config;
    if (!pwpConfig) { try { pwpConfig = JSON.parse(document.getElementById('jr-pwp-config')?.textContent || 'null'); } catch {} }
    const pwpActive = pwpConfig?.enabled === true && Date.now() >= Date.parse(pwpConfig.startsAt) && Date.now() <= Date.parse(pwpConfig.endsAt);
    if (pwpActive && pwpConfig?.previewOnly !== true && (typeof pwp?.beforeCheckout !== 'function' || typeof pwp?.preflightCheckout !== 'function')) {
      showError(String(config.locale || '').startsWith('zh') ? '加购功能尚未准备好，请刷新页面。' : 'The add-on feature is not ready. Please refresh this page.');
      return;
    }
    if (pwpConfig?.previewOnly === true) {
      const result = {ready:false,error:'preview',canSkip:true,message:String(config.locale || '').startsWith('zh') ? '这是优惠预览。优惠券尚未启用，不会加入加购商品。' : 'This is an offer preview. The voucher is not active and no add-on will be added.'};
      pwp.showCartError?.(result); showError(result.message); return;
    }
    // Pure validation precedes the main POST; an opted-in but incomplete pair cannot add a box.
    if (typeof pwp?.preflightCheckout === 'function') {
      const check = pwp.preflightCheckout({language:config.locale || 'en'});
      if (!check?.ready) { pwp.showCartError?.(check); showError(check?.message || (String(config.locale || '').startsWith('zh') ? '请先选满两片加购。' : 'Choose both add-on pieces first.')); return; }
    }
    if (!await ensureMainBox()) return;
    // Outside the main POST catch: a PWP failure must not mark the main box uncertain.
    if (typeof pwp?.beforeCheckout === 'function') {
      const result = await pwp.beforeCheckout({root:rootUrl, language:config.locale || 'en'});
      if (!result?.ready) {
        pwp.showCartError?.(result || {error:'cart',canSkip:false});
        showError(result?.message || (String(config.locale || '').startsWith('zh') ? '尚未确认加购，请检查购物车。' : 'The add-on has not been confirmed. Please review your cart.'));
        return;
      }
    }
    pwp?.markCheckoutStarted?.();
    goCheckout();
  };
  $('#checkout-box')?.addEventListener('click', event => {
    event.preventDefault();
    if (busy || checkoutPromise) return;
    busy = true; stage = 'adding'; render();
    checkoutPromise = performCheckout().catch(() => { showError(t('uncertain')); }).finally(() => {
      checkoutPromise = null;
      if (!navigating) { busy = false; stage = ''; render(); }
    });
  });
  window.addEventListener('pageshow', () => { busy = false; navigating = false; checkoutPromise = null; stage = ''; render(); });
  render();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-jeeroul-b"]) return;
  try {
    
(() => {
  'use strict';
  const configNode = document.getElementById('jrb-config');
  if (!configNode || configNode.dataset.initialized === 'true') return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  // Liquid's translation filter HTML-escapes text before JSON serialization.
  const decodeText = value => String(value ?? '').replace(/&(amp|lt|gt|quot|#39|#x27);/g, (match, entity) => ({amp:'&', lt:'<', gt:'>', quot:'"', '#39':"'", '#x27':"'"}[entity]));
  const flavours = Array.isArray(config.flavours) ? config.flavours.map(flavour => ({...flavour, zh:decodeText(flavour.zh), en:decodeText(flavour.en), short:decodeText(flavour.short), description:decodeText(flavour.description)})) : [];
  const packages = config.packages || {};
  if (!flavours.length || !packages[12] || !packages[20]) return;
  configNode.dataset.initialized = 'true';
  const $ = selector => document.querySelector(selector);
  const $$ = selector => [...document.querySelectorAll(selector)];
  const strings = config.strings || {};
  const t = (key, values = {}) => decodeText(strings[key === 'pack_quantity' && values.count === 1 ? 'pack_quantity_one' : key] || strings[key] || key).replace(/\{(\w+)\}/g, (match, name) => values[name] == null ? match : String(values[name]));
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[character]));
  const arrow = '<svg aria-hidden="true"><use href="#arrow"/></svg>';
  const mobileBuildLabel = $('#mobile-box')?.textContent.trim() || '';
  // Change only the alternate view; retain advertising parameters and page position.
  const updateLanguageLinks = () => $$('[data-language-view]').forEach(link => {
    const url = new URL(location.href);
    url.searchParams.set('view', link.dataset.languageView);
    link.href = url.href;
  });
  updateLanguageLinks();
  window.addEventListener('hashchange', updateLanguageLinks);

  const storageKey = `jeeroul:${config.landingId || 'lp-jeeroul-b'}:${config.product?.id || ''}`;
  const readStored = suffix => { try { return JSON.parse(sessionStorage.getItem(`${storageKey}:${suffix}`)); } catch { return null; } };
  const saveStored = (suffix, value) => { try { sessionStorage.setItem(`${storageKey}:${suffix}`, JSON.stringify(value)); } catch {} };
  const safeLocal = (value, fallback) => { try { const url = new URL(value || fallback, location.origin); return url.origin === location.origin ? url.pathname + url.search : fallback; } catch { return fallback; } };
  let rootUrl = safeLocal(window.Shopify?.routes?.root || config.rootUrl, '/');
  if (!rootUrl.endsWith('/')) rootUrl += '/';
  const cartUrl = safeLocal(config.cartUrl, `${rootUrl}cart`);
  const checkoutUrl = safeLocal(config.checkoutUrl, `${rootUrl}checkout`);
  const state = {size:12, quantities:Object.fromEntries(flavours.map(flavour => [flavour.id, 0])), detail:null};
  const saved = readStored('selection');
  if (saved && [12,20].includes(saved.size)) {
    state.size = saved.size;
    flavours.forEach(flavour => {
      const value = saved.quantities?.[flavour.id];
      state.quantities[flavour.id] = Number.isInteger(value) && value >= 0 && value <= 20 ? value : 0;
    });
  }
  let attempt = readStored('attempt');
  if (!attempt || !/^[a-zA-Z0-9_-]{8,100}$/.test(attempt.id || '') || !['adding','uncertain','added'].includes(attempt.status)) attempt = null;
  let busy = false;
  let navigating = false;
  let checkoutPromise = null;
  let stage = '';
  let toastTimer;
  let pendingMix = null;
  const total = () => flavours.reduce((sum, flavour) => sum + state.quantities[flavour.id], 0);
  const selectedPackage = () => packages[state.size];
  const purchasable = pack => pack && pack.available === true && /^\d+$/.test(String(pack.id)) && Number.isFinite(Number(pack.price)) && Number(pack.price) > 0;
  const signature = () => JSON.stringify([String(selectedPackage().id), state.size, flavours.map(flavour => state.quantities[flavour.id])]);
  const money = cents => {
    const value = Number(cents) / 100;
    if (config.currency === 'MYR') return `RM${value.toLocaleString(config.locale || 'zh-CN', {minimumFractionDigits:Number.isInteger(value) ? 0 : 2, maximumFractionDigits:2})}`;
    return new Intl.NumberFormat(config.locale || 'zh-CN', {style:'currency', currency:config.currency || 'MYR'}).format(value);
  };
  const mixText = () => flavours.filter(flavour => state.quantities[flavour.id] > 0).map(flavour => `${flavour.fulfilmentName || flavour.en} x ${state.quantities[flavour.id]}`).join(', ');
  const persistSelection = () => saveStored('selection', {size:state.size, quantities:state.quantities});
  const persistAttempt = () => saveStored('attempt', attempt);
  const toast = text => {
    const element = $('#toast');
    if (!element) return;
    element.textContent = text;
    element.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => element.classList.remove('show'), 3500);
  };
  const showError = message => {
    const element = $('#checkout-error');
    if (!element) return;
    element.textContent = message || '';
    element.hidden = !message;
    if (message) { element.setAttribute('tabindex', '-1'); element.focus({preventScroll:true}); }
  };
  const flavourGrid = $('#flavour-grid');
  const mixList = $('#mix-list');
  if (flavourGrid && !flavourGrid.querySelector('.flavour-card')) flavourGrid.innerHTML = flavours.map(flavour => `<article class="flavour-card"><button type="button" class="flavour-image" data-detail="${escape(flavour.id)}" aria-label="${escape(t('photo_label', {name:flavour.zh, energy:flavour.energy}))}"><img src="${escape(flavour.image)}" width="1080" height="1350" loading="lazy" alt="${escape(t('photo_alt', {english:flavour.en, name:flavour.zh, energy:flavour.energy}))}"><span class="zoom-label" aria-hidden="true">+</span></button><div class="flavour-card-bottom"><div><h3>${escape(flavour.zh)}</h3><p class="flavour-card-en" lang="en">${escape(flavour.en)}</p><p>${escape(flavour.short)}</p></div><button type="button" class="flavour-add" data-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></article>`).join('');
  if (mixList && !mixList.querySelector('.mix-row')) mixList.innerHTML = flavours.map(flavour => `<div class="mix-row"><button type="button" class="mix-thumb" data-detail="${escape(flavour.id)}" aria-label="${escape(t('detail_label', {name:flavour.zh}))}"><img src="${escape(flavour.image)}" alt="${escape(flavour.zh)}" width="1080" height="1350" loading="lazy"></button><div class="mix-name"><h3>${escape(flavour.zh)}</h3><p>${escape(flavour.en)}</p></div><div class="stepper"><button type="button" data-minus="${escape(flavour.id)}" aria-label="${escape(t('minus_label', {name:flavour.zh}))}">−</button><output data-qty="${escape(flavour.id)}" aria-label="${escape(t('quantity_label', {name:flavour.zh}))}">0</output><button type="button" data-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></div>`).join('');
  $$('[data-package-price]').forEach(element => { const pack = packages[element.dataset.packagePrice]; if (pack) element.textContent = money(pack.price); });
  $$('[data-package-per-pack]').forEach(element => { const size = Number(element.dataset.packagePerPack); if (packages[size]) element.textContent = t('per_pack', {price:money(packages[size].price / size)}); });
  const availablePackages = [12,20].filter(size => purchasable(packages[size]));
  if (availablePackages.length) $$('[data-from-price]').forEach(element => { element.textContent = money(Math.min(...availablePackages.map(size => packages[size].price / size))); });
  $$('[data-view-cart], #view-cart').forEach(element => { element.href = cartUrl; });
  const updateWhatsApp = () => {
    if (!config.whatsappUrl) return;
    try {
      const url = new URL(config.whatsappUrl);
      if (!['wa.me','api.whatsapp.com','web.whatsapp.com'].includes(url.hostname) || url.protocol !== 'https:') return;
      url.searchParams.set('text', t('whatsapp_message', {size:state.size, mix:mixText() || t('no_mix')}));
      $$('#contact-whatsapp, [data-contact-whatsapp]').forEach(element => { element.href = url.href; });
    } catch {}
  };
  let pwpPackageSignature = '';
  const publishPwpPackage = (force = false) => {
    const detail = {size:state.size,price:selectedPackage().price,currency:config.currency || 'MYR'};
    const next = JSON.stringify(detail);
    if (force || next !== pwpPackageSignature) {
      pwpPackageSignature = next;
      document.dispatchEvent(new CustomEvent('jeeroul:package-change',{detail,bubbles:true}));
    }
  };
  window.addEventListener('jeeroul:pwp-ready', () => publishPwpPackage(true));
  const render = () => {
    window.JeeroulPwp?.setBusy?.(busy);
    publishPwpPackage();
    const count = total();
    const remaining = state.size - count;
    const available = purchasable(selectedPackage());
    $$('[data-count]').forEach(element => { element.textContent = count; });
    $$('[data-size-label]').forEach(element => { element.textContent = state.size; });
    $$('[data-price]').forEach(element => { element.textContent = money(selectedPackage().price); });
    $$('[data-size]').forEach(element => {
      const size = Number(element.dataset.size);
      element.setAttribute('aria-pressed', String(size === state.size));
      element.disabled = busy;
      element.classList.toggle('is-unavailable', !purchasable(packages[size]));
      const status = element.querySelector('[data-package-status]');
      if (status) status.textContent = purchasable(packages[size]) ? '' : t('sold_out');
    });
    $$('[data-qty]').forEach(element => { element.textContent = state.quantities[element.dataset.qty]; });
    $$('[data-minus]').forEach(element => { element.disabled = busy || state.quantities[element.dataset.minus] === 0; });
    $$('[data-add]').forEach(element => { element.disabled = busy || remaining <= 0; });
    ['#even-mix','#clear-mix','#confirm-remix'].forEach(selector => { if ($(selector)) $(selector).disabled = busy; });
    const progress = $('#mix-progress');
    if (progress) { progress.max = state.size; progress.value = Math.min(count, state.size); }
    if ($('[data-percent]')) $('[data-percent]').textContent = `${Math.round(count / state.size * 100)}%`;
    const status = $('#mix-status');
    if (status) { status.textContent = remaining > 0 ? t('need_more', {count:remaining}) : remaining < 0 ? t('remove_extra', {count:-remaining}) : t('mix_complete'); status.style.color = remaining < 0 ? '#a64224' : ''; }
    const review = $('#review-box');
    if (review) {
      review.disabled = busy || remaining !== 0 || !available;
      review.innerHTML = escape(!available ? t('sold_out') : remaining > 0 ? t('need_more_short', {count:remaining}) : remaining < 0 ? t('remove_extra_short', {count:-remaining}) : t('review_mix')) + arrow;
    }
    const mobileReview = $('#mobile-box');
    if (mobileReview) {
      const ready = remaining === 0 && available;
      mobileReview.disabled = busy;
      mobileReview.innerHTML = escape(ready ? t('review_mix') : mobileBuildLabel) + arrow;
      mobileReview.setAttribute('aria-controls', ready ? 'box-dialog' : 'build');
      if (ready) mobileReview.setAttribute('aria-haspopup', 'dialog');
      else mobileReview.removeAttribute('aria-haspopup');
    }
    const checkout = $('#checkout-box');
    if (checkout) {
      const matchesAttempt = attempt?.signature === signature();
      const label = busy ? t(stage || 'adding') : matchesAttempt && attempt.status === 'added' ? t('continue_checkout') : attempt && ['adding','uncertain'].includes(attempt.status) ? t('check_cart') : t('checkout');
      checkout.textContent = !available ? t('sold_out') : label;
      checkout.disabled = busy || remaining !== 0 || !available;
      checkout.setAttribute('aria-busy', String(busy));
    }
    const dialogAdd = $('#dialog-add');
    if (dialogAdd) dialogAdd.disabled = busy || remaining <= 0;
    const feedback = $('#dialog-feedback');
    if (feedback) feedback.textContent = remaining < 0 ? t('box_over', {total:count, count:-remaining}) : remaining === 0 ? t('dialog_full') : '';
    updateWhatsApp();
    persistSelection();
  };
  const add = (id, notify = false) => {
    const flavour = flavours.find(item => item.id === id);
    if (busy || !flavour) return false;
    if (total() >= state.size) { toast(total() > state.size ? t('box_over', {total:total(), count:total()-state.size}) : t('box_full', {size:state.size})); return false; }
    state.quantities[id] += 1;
    showError('');
    render();
    if (notify) toast(t('added_flavour', {name:flavour.zh, total:total(), size:state.size}));
    return true;
  };
  const showFlavour = id => {
    const flavour = flavours.find(item => item.id === id);
    const dialog = $('#flavour-dialog');
    if (!flavour || !dialog) return;
    state.detail = id;
    $('#flavour-dialog-title').textContent = flavour.zh;
    $('#flavour-dialog-en').textContent = flavour.en;
    $('#flavour-dialog-description').textContent = flavour.description;
    $('#flavour-dialog-energy').textContent = flavour.energy;
    $('#flavour-dialog-image').src = flavour.image;
    $('#flavour-dialog-image').alt = t('photo_alt', {english:flavour.en, name:flavour.zh, energy:flavour.energy});
    render();
    dialog.showModal();
    dialog.scrollTop = 0;
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const detail = event.target.closest('[data-detail]');
    const plus = event.target.closest('[data-add]');
    const minus = event.target.closest('[data-minus]');
    const size = event.target.closest('[data-size]');
    const close = event.target.closest('[data-close]');
    if (detail) showFlavour(detail.dataset.detail);
    if (plus) add(plus.dataset.add, !plus.closest('.stepper'));
    if (minus && !busy && Object.hasOwn(state.quantities, minus.dataset.minus)) { state.quantities[minus.dataset.minus] = Math.max(0, state.quantities[minus.dataset.minus] - 1); showError(''); render(); }
    if (size && !busy && [12,20].includes(Number(size.dataset.size))) { state.size = Number(size.dataset.size); showError(''); render(); }
    if (close) close.closest('dialog')?.close();
  });
  const calculateEvenMix = () => {
    const base = Math.floor(state.size / flavours.length);
    const extra = state.size % flavours.length;
    return {size:state.size, quantities:Object.fromEntries(flavours.map((flavour, index) => [flavour.id, base + (index < extra ? 1 : 0)]))};
  };
  const applyEvenMix = mix => {
    if (busy || !mix || mix.size !== state.size) return;
    flavours.forEach(flavour => { state.quantities[flavour.id] = mix.quantities[flavour.id]; });
    showError(''); render(); toast(t('even_mix', {size:state.size}));
  };
  $('#pack-photo-open')?.addEventListener('click', () => { if (!busy) $('#pack-photo-dialog')?.showModal(); });
  $('#even-mix')?.addEventListener('click', () => {
    if (busy) return;
    const mix = calculateEvenMix();
    if (total() === 0) { applyEvenMix(mix); return; }
    const dialog = $('#mix-replace-dialog');
    if (!dialog) return;
    pendingMix = mix;
    $('#mix-replace-package').textContent = t('package_summary', {size:mix.size});
    $('#mix-replace-items').innerHTML = flavours.map(flavour => `<li><span>${escape(flavour.zh)}</span><strong>${escape(t('pack_quantity', {count:mix.quantities[flavour.id]}))}</strong></li>`).join('');
    dialog.showModal();
  });
  $('#confirm-remix')?.addEventListener('click', () => {
    if (busy || !pendingMix) return;
    const mix = pendingMix;
    pendingMix = null;
    $('#mix-replace-dialog').close();
    applyEvenMix(mix);
  });
  $('#mix-replace-dialog')?.addEventListener('close', () => { pendingMix = null; });
  $('#clear-mix')?.addEventListener('click', () => { if (!busy) { flavours.forEach(flavour => { state.quantities[flavour.id] = 0; }); showError(''); render(); } });
  $('#dialog-add')?.addEventListener('click', () => {
    if (!add(state.detail)) return;
    $('#flavour-dialog').close();
    $$('[data-minus]').find(element => element.dataset.minus === state.detail)?.focus({preventScroll:true});
    $('#build')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    toast(t('continue_mix'));
  });
  const showBox = () => {
    if (busy || total() !== state.size || !purchasable(selectedPackage())) return;
    $('#box-dialog-package').textContent = t('package_summary', {size:state.size});
    $('#box-dialog-items').innerHTML = flavours.filter(flavour => state.quantities[flavour.id] > 0).map(flavour => `<li><span>${escape(flavour.zh)}</span><strong>${escape(t('pack_quantity', {count:state.quantities[flavour.id]}))}</strong></li>`).join('');
    showError(''); render(); $('#box-dialog').showModal();
  };
  $('#review-box')?.addEventListener('click', showBox);
  $('#mobile-box')?.addEventListener('click', () => {
    if (busy) return;
    if (total() === state.size && purchasable(selectedPackage())) showBox();
    else $('#build')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  $$('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }));
  const request = async (path, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(`${rootUrl}${path}`, {...options, credentials:'same-origin', cache:'no-store', signal:controller.signal, headers:{Accept:'application/json', ...(options.headers || {})}});
      let data;
      try { data = await response.json(); } catch { throw new Error('invalid_response'); }
      return {response, data};
    } finally { clearTimeout(timer); }
  };
  const reconcile = async pending => {
    stage = 'checking'; render();
    const {response, data} = await request('cart.js');
    if (!response.ok || !Array.isArray(data.items)) throw new Error('cart_unavailable');
    $$('[data-cart-count]').forEach(element => { element.textContent = data.item_count; });
    const items = data.items.filter(item => item.properties?._jrb_attempt === pending.id);
    if (!items.length) return 'missing';
    if (items.length !== 1 || String(items[0].variant_id || items[0].id) !== String(pending.variantId) || items[0].quantity !== 1 || items[0].properties?.['Flavour mix'] !== pending.mix) return 'changed';
    return 'found';
  };
  const makeAttempt = () => {
    const random = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now().toString(36)}-${Array.from(crypto.getRandomValues(new Uint32Array(3))).map(value => value.toString(36)).join('-')}`;
    return {id:random, signature:signature(), variantId:String(selectedPackage().id), mix:mixText(), status:'adding', createdAt:Date.now()};
  };
  const makeProperties = pending => {
    const properties = {'Flavour mix':pending.mix, _landing_page:config.landingId || 'lp-jeeroul-b', _jrb_attempt:pending.id};
    const params = new URLSearchParams(location.search);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key => {
      const value = params.get(key);
      if (value) properties[`_${key}`] = value.replace(/[\u0000-\u001F\u007F]/g, '').slice(0, 150);
    });
    return properties;
  };
  const goCheckout = () => {
    stage = 'redirecting'; navigating = true; render();
    const form = document.createElement('form');
    form.method = 'post'; form.action = cartUrl; form.hidden = true;
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = 'checkout'; input.value = '1';
    form.append(input); document.body.append(form);
    try { HTMLFormElement.prototype.submit.call(form); } catch { location.assign(checkoutUrl); }
  };
  const ensureMainBox = async () => {
    showError('');
    if (total() !== state.size) { showError(t('invalid_mix', {size:state.size})); return; }
    if (!purchasable(selectedPackage())) { showError(t('unavailable')); return; }
    if (attempt) {
      let result;
      try { result = await reconcile(attempt); } catch { showError(t('uncertain')); return; }
      if (result === 'changed') { showError(t('changed_cart')); return; }
      if (result === 'found') {
        attempt.status = 'added'; persistAttempt();
        if (attempt.signature === signature()) { return true; }
      } else if (attempt.status !== 'added') {
        attempt.status = 'uncertain'; persistAttempt(); showError(t('uncertain_not_found')); return;
      }
    }
    attempt = makeAttempt(); persistAttempt();
    stage = 'adding'; render();
    try {
      const {response, data} = await request('cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:attempt.variantId, quantity:1, properties:makeProperties(attempt)}]})});
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) { attempt = null; persistAttempt(); showError(t('add_failed')); return; }
        throw new Error('uncertain_add');
      }
      const items = Array.isArray(data.items) ? data.items : [data];
      const added = items.find(item => item.properties?._jrb_attempt === attempt.id);
      if (!added || String(added.variant_id || added.id) !== attempt.variantId || added.quantity !== 1 || added.properties?.['Flavour mix'] !== attempt.mix) throw new Error('unconfirmed_add');
      attempt.status = 'added'; persistAttempt(); return true;
    } catch {
      attempt.status = 'uncertain'; persistAttempt();
      try {
        const result = await reconcile(attempt);
        if (result === 'found') { attempt.status = 'added'; persistAttempt(); return true; }
        showError(t(result === 'changed' ? 'changed_cart' : 'uncertain'));
      } catch { showError(t('uncertain')); }
    }
  };
  // The main-box attempt remains independent from the optional PWP transaction.
  const performCheckout = async () => {
    const pwp = window.JeeroulPwp;
    let pwpConfig = pwp?.config;
    if (!pwpConfig) { try { pwpConfig = JSON.parse(document.getElementById('jr-pwp-config')?.textContent || 'null'); } catch {} }
    const pwpActive = pwpConfig?.enabled === true && Date.now() >= Date.parse(pwpConfig.startsAt) && Date.now() <= Date.parse(pwpConfig.endsAt);
    if (pwpActive && pwpConfig?.previewOnly !== true && (typeof pwp?.beforeCheckout !== 'function' || typeof pwp?.preflightCheckout !== 'function')) {
      showError(String(config.locale || '').startsWith('zh') ? '加购功能尚未准备好，请刷新页面。' : 'The add-on feature is not ready. Please refresh this page.');
      return;
    }
    if (pwpConfig?.previewOnly === true) {
      const result = {ready:false,error:'preview',canSkip:true,message:String(config.locale || '').startsWith('zh') ? '这是优惠预览。优惠券尚未启用，不会加入加购商品。' : 'This is an offer preview. The voucher is not active and no add-on will be added.'};
      pwp.showCartError?.(result); showError(result.message); return;
    }
    // Pure validation precedes the main POST; an opted-in but incomplete pair cannot add a box.
    if (typeof pwp?.preflightCheckout === 'function') {
      const check = pwp.preflightCheckout({language:config.locale || 'en'});
      if (!check?.ready) { pwp.showCartError?.(check); showError(check?.message || (String(config.locale || '').startsWith('zh') ? '请先选满两片加购。' : 'Choose both add-on pieces first.')); return; }
    }
    if (!await ensureMainBox()) return;
    // Outside the main POST catch: a PWP failure must not mark the main box uncertain.
    if (typeof pwp?.beforeCheckout === 'function') {
      const result = await pwp.beforeCheckout({root:rootUrl, language:config.locale || 'en'});
      if (!result?.ready) {
        pwp.showCartError?.(result || {error:'cart',canSkip:false});
        showError(result?.message || (String(config.locale || '').startsWith('zh') ? '尚未确认加购，请检查购物车。' : 'The add-on has not been confirmed. Please review your cart.'));
        return;
      }
    }
    pwp?.markCheckoutStarted?.();
    goCheckout();
  };
  $('#checkout-box')?.addEventListener('click', event => {
    event.preventDefault();
    if (busy || checkoutPromise) return;
    busy = true; stage = 'adding'; render();
    checkoutPromise = performCheckout().catch(() => { showError(t('uncertain')); }).finally(() => {
      checkoutPromise = null;
      if (!navigating) { busy = false; stage = ''; render(); }
    });
  });
  window.addEventListener('pageshow', () => { busy = false; navigating = false; checkoutPromise = null; stage = ''; render(); });
  render();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-jeeroul-c-en"]) return;
  try {
    
(() => {
  'use strict';
  const configNode = document.getElementById('jrc-config');
  if (!configNode || configNode.dataset.initialized === 'true') return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  // Liquid's translation filter HTML-escapes text before JSON serialization.
  const decodeText = value => String(value ?? '').replace(/&(amp|lt|gt|quot|#39|#x27);/g, (match, entity) => ({amp:'&', lt:'<', gt:'>', quot:'"', '#39':"'", '#x27':"'"}[entity]));
  const flavours = Array.isArray(config.flavours) ? config.flavours.map(flavour => ({...flavour, zh:decodeText(flavour.zh), en:decodeText(flavour.en), short:decodeText(flavour.short), description:decodeText(flavour.description)})) : [];
  const packages = config.packages || {};
  if (!flavours.length || !packages[12] || !packages[20]) return;
  configNode.dataset.initialized = 'true';
  const $ = selector => document.querySelector(selector);
  const $$ = selector => [...document.querySelectorAll(selector)];
  const strings = config.strings || {};
  const t = (key, values = {}) => decodeText(strings[key === 'pack_quantity' && values.count === 1 ? 'pack_quantity_one' : key] || strings[key] || key).replace(/\{(\w+)\}/g, (match, name) => values[name] == null ? match : String(values[name]));
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[character]));
  const arrow = '<svg aria-hidden="true"><use href="#arrow"/></svg>';
  const mobileBuildLabel = $('#mobile-box')?.textContent.trim() || '';
  // Change only the alternate view; retain advertising parameters and page position.
  const updateLanguageLinks = () => $$('[data-language-view]').forEach(link => {
    const url = new URL(location.href);
    url.searchParams.set('view', link.dataset.languageView);
    link.href = url.href;
  });
  updateLanguageLinks();
  window.addEventListener('hashchange', updateLanguageLinks);

  const storageKey = `jeeroul:${config.landingId || 'lp-jeeroul-c'}:${config.product?.id || ''}`;
  const readStored = suffix => { try { return JSON.parse(sessionStorage.getItem(`${storageKey}:${suffix}`)); } catch { return null; } };
  const saveStored = (suffix, value) => { try { sessionStorage.setItem(`${storageKey}:${suffix}`, JSON.stringify(value)); } catch {} };
  const safeLocal = (value, fallback) => { try { const url = new URL(value || fallback, location.origin); return url.origin === location.origin ? url.pathname + url.search : fallback; } catch { return fallback; } };
  let rootUrl = safeLocal(window.Shopify?.routes?.root || config.rootUrl, '/');
  if (!rootUrl.endsWith('/')) rootUrl += '/';
  const cartUrl = safeLocal(config.cartUrl, `${rootUrl}cart`);
  const checkoutUrl = safeLocal(config.checkoutUrl, `${rootUrl}checkout`);
  const region = config.localization || {};
  const copyMix = mix => ({size:mix.size, quantities:{...mix.quantities}});
  const validHandoffMix = (mix, draft = false) => mix && [12,20].includes(mix.size) && mix.quantities && Object.keys(mix.quantities).length === flavours.length && flavours.every(flavour => Number.isInteger(mix.quantities[flavour.id]) && mix.quantities[flavour.id] >= 0 && mix.quantities[flavour.id] <= (draft ? mix.size : 20)) && flavours.reduce((sum, flavour) => sum + mix.quantities[flavour.id], 0) <= (draft ? mix.size : 20);
  const state = {size:12, quantities:Object.fromEntries(flavours.map(flavour => [flavour.id, 0])), detail:null};
  const saved = readStored('selection');
  if (saved && [12,20].includes(saved.size)) {
    state.size = saved.size;
    flavours.forEach(flavour => {
      const value = saved.quantities?.[flavour.id];
      state.quantities[flavour.id] = Number.isInteger(value) && value >= 0 && value <= 20 ? value : 0;
    });
  }
  // A country change keeps committed choices and the unsaved draft separate.
  // Consume only this tab's short-lived handoff, never selections supplied in a URL.
  const handoff = readStored('region_handoff');
  const returnUrl = new URL(location.href);
  const regionToken = returnUrl.searchParams.get('jrc_region_return');
  let restoredDraft = null;
  if (regionToken) {
    const age = Date.now() - handoff?.createdAt;
    if (handoff?.version === 1 && handoff.token === regionToken && /^[a-zA-Z0-9_-]{8,100}$/.test(regionToken) && Number.isFinite(handoff.createdAt) && Number.isFinite(age) && age >= 0 && age <= 600000 && handoff.productId === String(config.product?.id) && handoff.view === config.landingView && returnUrl.searchParams.get('view') === config.landingView && validHandoffMix(handoff.committed) && validHandoffMix(handoff.draft, true) && handoff.draft.size === handoff.committed.size) {
      state.size = handoff.committed.size;
      state.quantities = {...handoff.committed.quantities};
      restoredDraft = copyMix(handoff.draft);
    }
    try { sessionStorage.removeItem(`${storageKey}:region_handoff`); } catch {}
    returnUrl.searchParams.delete('jrc_region_return');
    try { history.replaceState(history.state, '', returnUrl.pathname + returnUrl.search + returnUrl.hash); } catch {}
    updateLanguageLinks();
  } else if (handoff && (!Number.isFinite(handoff.createdAt) || Date.now() - handoff.createdAt > 600000)) {
    try { sessionStorage.removeItem(`${storageKey}:region_handoff`); } catch {}
  }
  let attempt = readStored('attempt');
  if (!attempt || !/^[a-zA-Z0-9_-]{8,100}$/.test(attempt.id || '') || !['adding','uncertain','added'].includes(attempt.status)) attempt = null;
  let busy = false;
  let navigating = false;
  let checkoutPromise = null;
  let stage = '';
  let toastTimer;
  let pendingMix = null;
  let navigationTimer;
  const draftTotal = () => pendingMix ? flavours.reduce((sum, flavour) => sum + pendingMix.quantities[flavour.id], 0) : 0;
  const validDraft = () => pendingMix && pendingMix.size === state.size && flavours.every(flavour => Number.isInteger(pendingMix.quantities[flavour.id]) && pendingMix.quantities[flavour.id] >= 0 && pendingMix.quantities[flavour.id] <= state.size) && draftTotal() === state.size;
  const draftMatchesState = () => pendingMix && pendingMix.size === state.size && flavours.every(flavour => pendingMix.quantities[flavour.id] === state.quantities[flavour.id]);
  const total = () => flavours.reduce((sum, flavour) => sum + state.quantities[flavour.id], 0);
  const selectedPackage = () => packages[state.size];
  const validId = value => (typeof value === 'string' || (typeof value === 'number' && Number.isSafeInteger(value))) && /^[1-9]\d*$/.test(String(value));
  const validPackage = pack => pack && validId(pack.id) && Number.isSafeInteger(pack.price) && pack.price > 0;
  // Keep the displayed variant and price immutable; a read-only check confirms that exact offer.
  const stockStates = Object.fromEntries([12,20].map(size => {
    const pack = packages[size];
    return [size, !validPackage(pack) || typeof pack.available !== 'boolean' ? 'error' : pack.available ? 'unverified' : 'sold_out'];
  }));
  let stockPromise = null;
  const stockMessage = status => {
    const key = {checking:'stock_checking', sold_out:'stock_sold_out', error:'stock_error', price_changed:'stock_price_changed'}[status];
    return key ? t(key) : '';
  };
  const stockConfirmed = () => stockStates[state.size] === 'available' && validPackage(selectedPackage());
  const signature = () => JSON.stringify([String(selectedPackage().id), state.size, flavours.map(flavour => state.quantities[flavour.id])]);
  const money = cents => {
    const value = Number(cents) / 100;
    if (config.currency === 'MYR') return `RM${value.toLocaleString(config.locale || 'zh-CN', {minimumFractionDigits:Number.isInteger(value) ? 0 : 2, maximumFractionDigits:2})}`;
    return new Intl.NumberFormat(config.locale || 'zh-CN', {style:'currency', currency:config.currency || 'MYR'}).format(value);
  };
  const mixText = () => flavours.filter(flavour => state.quantities[flavour.id] > 0).map(flavour => `${flavour.fulfilmentName || flavour.en} x ${state.quantities[flavour.id]}`).join(', ');
  const persistSelection = () => saveStored('selection', {size:state.size, quantities:state.quantities});
  const persistAttempt = () => saveStored('attempt', attempt);
  const toast = text => {
    const element = $('#toast');
    if (!element) return;
    element.textContent = text;
    element.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => element.classList.remove('show'), 3500);
  };
  const showError = message => {
    const element = $('#checkout-error');
    if (!element) return;
    element.textContent = message || '';
    element.hidden = !message;
    if (message) { element.setAttribute('tabindex', '-1'); element.focus({preventScroll:true}); }
  };
  const flavourGrid = $('#flavour-grid');
  const mixList = $('#mix-list');
  if (flavourGrid && !flavourGrid.querySelector('.flavour-card')) flavourGrid.innerHTML = flavours.map(flavour => `<article class="flavour-card"><button type="button" class="flavour-image" data-detail="${escape(flavour.id)}" aria-label="${escape(t('photo_label', {name:flavour.zh, energy:flavour.energy}))}"><img src="${escape(flavour.image)}" width="1080" height="1350" loading="lazy" alt="${escape(t('photo_alt', {english:flavour.en, name:flavour.zh, energy:flavour.energy}))}"><span class="zoom-label" aria-hidden="true">+</span></button><div class="flavour-card-bottom"><div><h3>${escape(flavour.zh)}</h3><p class="flavour-card-en" lang="en">${escape(flavour.en)}</p><p>${escape(flavour.short)}</p></div><button type="button" class="flavour-add" data-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></article>`).join('');
  if (mixList && !mixList.querySelector('.mix-row')) mixList.innerHTML = flavours.map(flavour => `<div class="mix-row"><button type="button" class="mix-thumb" data-detail="${escape(flavour.id)}" aria-label="${escape(t('detail_label', {name:flavour.zh}))}"><img src="${escape(flavour.image)}" alt="${escape(flavour.zh)}" width="1080" height="1350" loading="lazy"></button><div class="mix-name"><h3>${escape(flavour.zh)}</h3><p>${escape(flavour.en)}</p></div><div class="stepper"><button type="button" data-minus="${escape(flavour.id)}" aria-label="${escape(t('minus_label', {name:flavour.zh}))}">−</button><output data-qty="${escape(flavour.id)}" aria-label="${escape(t('quantity_label', {name:flavour.zh}))}">0</output><button type="button" data-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></div>`).join('');
  $$('[data-package-price]').forEach(element => { const pack = packages[element.dataset.packagePrice]; if (pack) element.textContent = money(pack.price); });
  $$('[data-package-per-pack]').forEach(element => { const size = Number(element.dataset.packagePerPack); if (packages[size]) element.textContent = t('per_pack', {price:money(packages[size].price / size)}); });
  const availablePackages = [12,20].filter(size => validPackage(packages[size]) && packages[size].available === true);
  if (availablePackages.length) $$('[data-from-price]').forEach(element => { element.textContent = money(Math.min(...availablePackages.map(size => packages[size].price / size))); });
  $$('[data-view-cart], #view-cart').forEach(element => { element.href = cartUrl; });
  const updateWhatsApp = () => {
    if (!config.whatsappUrl) return;
    try {
      const url = new URL(config.whatsappUrl);
      if (!['wa.me','api.whatsapp.com','web.whatsapp.com'].includes(url.hostname) || url.protocol !== 'https:') return;
      url.searchParams.set('text', t('whatsapp_message', {size:state.size, mix:mixText() || t('no_mix')}));
      $$('#contact-whatsapp, [data-contact-whatsapp]').forEach(element => { element.href = url.href; });
    } catch {}
  };
  let pwpPackageSignature = '';
  const publishPwpPackage = (force = false) => {
    const detail = {size:state.size,price:selectedPackage().price,currency:config.currency || 'MYR'};
    const next = JSON.stringify(detail);
    if (force || next !== pwpPackageSignature) {
      pwpPackageSignature = next;
      document.dispatchEvent(new CustomEvent('jeeroul:package-change',{detail,bubbles:true}));
    }
  };
  window.addEventListener('jeeroul:pwp-ready', () => publishPwpPackage(true));
  const render = () => {
    window.JeeroulPwp?.setBusy?.(busy);
    publishPwpPackage();
    const count = total();
    const remaining = state.size - count;
    const stockStatus = stockStates[state.size];
    const available = stockConfirmed();
    $$('[data-count]').forEach(element => { element.textContent = count; });
    $$('[data-size-label]').forEach(element => { element.textContent = state.size; });
    $$('[data-price]').forEach(element => { element.textContent = money(selectedPackage().price); });
    $$('[data-size]').forEach(element => {
      const size = Number(element.dataset.size);
      element.setAttribute('aria-pressed', String(size === state.size));
      element.disabled = busy;
      element.classList.toggle('is-unavailable', ['sold_out','error','price_changed'].includes(stockStates[size]));
      const status = element.querySelector('[data-package-status]');
      if (status) status.textContent = stockStates[size] === 'sold_out' ? t('sold_out') : stockStates[size] === 'checking' ? t('stock_checking') : ['error','price_changed'].includes(stockStates[size]) ? t('stock_unconfirmed') : '';
    });
    $$('[data-qty]').forEach(element => { element.textContent = state.quantities[element.dataset.qty]; });
    $$('[data-minus]').forEach(element => { element.disabled = busy || state.quantities[element.dataset.minus] === 0; });
    $$('[data-add]').forEach(element => { element.disabled = busy || remaining <= 0; });
    ['#even-mix','#clear-mix'].forEach(selector => { if ($(selector)) $(selector).disabled = busy; });
    const cProgress = $('#c-selection-progress');
    if (cProgress) { cProgress.style.width = `${Math.min(100, count / state.size * 100)}%`; cProgress.setAttribute('aria-valuemax', state.size); cProgress.setAttribute('aria-valuenow', Math.min(count, state.size)); }
    const progress = $('#mix-progress');
    if (progress) { progress.max = state.size; progress.value = Math.min(count, state.size); }
    if ($('[data-percent]')) $('[data-percent]').textContent = `${Math.round(count / state.size * 100)}%`;
    const status = $('#mix-status');
    if (status) { status.textContent = remaining > 0 ? t('need_more', {count:remaining}) : remaining < 0 ? t('remove_extra', {count:-remaining}) : t('mix_complete'); status.style.color = remaining < 0 ? '#a64224' : ''; }
    const review = $('#review-box');
    if (review) {
      review.disabled = busy || remaining !== 0;
      review.innerHTML = escape(remaining > 0 ? t('need_more_short', {count:remaining}) : remaining < 0 ? t('remove_extra_short', {count:-remaining}) : t('review_mix')) + arrow;
    }
    const mobileReview = $('#mobile-box');
    if (mobileReview) {
      const ready = remaining === 0;
      mobileReview.disabled = busy;
      mobileReview.innerHTML = escape(ready ? t('review_mix') : mobileBuildLabel) + arrow;
      mobileReview.setAttribute('aria-controls', ready ? 'box-dialog' : 'build');
      if (ready) mobileReview.setAttribute('aria-haspopup', 'dialog');
      else mobileReview.removeAttribute('aria-haspopup');
    }
    const checkout = $('#checkout-box');
    if (checkout) {
      const matchesAttempt = attempt?.signature === signature();
      const label = busy ? t(stage || 'adding') : matchesAttempt && attempt.status === 'added' ? t('continue_checkout') : attempt && ['adding','uncertain'].includes(attempt.status) ? t('check_cart') : t('checkout');
      checkout.textContent = stockStatus === 'sold_out' ? t('sold_out') : stockStatus === 'checking' ? t('stock_checking') : label;
      checkout.disabled = busy || remaining !== 0 || !available || !validDraft() || !draftMatchesState();
      checkout.setAttribute('aria-busy', String(busy || stockStatus === 'checking'));
    }
    const stockNotice = $('#c-stock-status');
    if (stockNotice) { stockNotice.textContent = stockMessage(stockStatus); stockNotice.hidden = !stockNotice.textContent; stockNotice.dataset.state = stockStatus; }
    const retryStock = $('#retry-stock');
    if (retryStock) { retryStock.hidden = ['unverified','available'].includes(stockStatus); retryStock.disabled = busy || stockStatus === 'checking'; }
    const otherCountry = !!region.countryCode && region.countryCode !== 'MY';
    const needsRegionHelp = otherCountry || ['sold_out','error'].includes(stockStatus);
    const regionNote = $('#c-region-note');
    if (regionNote) { regionNote.hidden = !needsRegionHelp; regionNote.textContent = needsRegionHelp ? t(otherCountry ? 'region_delivery_note' : 'region_recheck_note') : ''; }
    const recovery = $('#c-region-recovery');
    if (recovery) recovery.hidden = region.malaysiaAvailable !== true || !needsRegionHelp;
    const countryButton = $('#c-deliver-malaysia');
    if (countryButton) countryButton.disabled = busy;
    const dialogAdd = $('#dialog-add');
    if (dialogAdd) dialogAdd.disabled = busy || remaining <= 0;
    const feedback = $('#dialog-feedback');
    if (feedback) feedback.textContent = remaining < 0 ? t('box_over', {total:count, count:-remaining}) : remaining === 0 ? t('dialog_full') : '';
    renderDraft();
    updateWhatsApp();
    persistSelection();
  };
  const add = (id, notify = false) => {
    const flavour = flavours.find(item => item.id === id);
    if (busy || !flavour) return false;
    if (total() >= state.size) { toast(total() > state.size ? t('box_over', {total:total(), count:total()-state.size}) : t('box_full', {size:state.size})); return false; }
    state.quantities[id] += 1;
    showError('');
    render();
    if (notify) toast(t('added_flavour', {name:flavour.zh, total:total(), size:state.size}));
    return true;
  };
  const showFlavour = id => {
    const flavour = flavours.find(item => item.id === id);
    const dialog = $('#flavour-dialog');
    if (!flavour || !dialog) return;
    state.detail = id;
    $('#flavour-dialog-title').textContent = flavour.zh;
    $('#flavour-dialog-en').textContent = flavour.en;
    $('#flavour-dialog-description').textContent = flavour.description;
    $('#flavour-dialog-energy').textContent = flavour.energy;
    $('#flavour-dialog-image').src = flavour.image;
    $('#flavour-dialog-image').alt = t('photo_alt', {english:flavour.en, name:flavour.zh, energy:flavour.energy});
    render();
    dialog.showModal();
    dialog.scrollTop = 0;
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const detail = event.target.closest('[data-detail]');
    const plus = event.target.closest('[data-add]');
    const minus = event.target.closest('[data-minus]');
    const size = event.target.closest('[data-size]');
    const close = event.target.closest('[data-close]');
    const draftPlus = event.target.closest('[data-draft-add]');
    const draftMinus = event.target.closest('[data-draft-minus]');
    if ((draftPlus || draftMinus) && !busy && pendingMix && $('#box-dialog')?.open) {
      const id = draftPlus ? draftPlus.dataset.draftAdd : draftMinus.dataset.draftMinus;
      if (!Object.hasOwn(pendingMix.quantities, id)) return;
      if (draftPlus && draftTotal() < pendingMix.size) pendingMix.quantities[id] += 1;
      if (draftMinus) pendingMix.quantities[id] = Math.max(0, pendingMix.quantities[id] - 1);
      showError(''); render();
      return;
    }
    if (detail) showFlavour(detail.dataset.detail);
    if (plus) add(plus.dataset.add, !plus.closest('.stepper'));
    if (minus && !busy && Object.hasOwn(state.quantities, minus.dataset.minus)) { state.quantities[minus.dataset.minus] = Math.max(0, state.quantities[minus.dataset.minus] - 1); showError(''); render(); }
    if (size && !busy && [12,20].includes(Number(size.dataset.size))) { state.size = Number(size.dataset.size); showError(''); render(); }
    if (close) close.closest('dialog')?.close();
  });
  const calculateEvenMix = () => {
    const base = Math.floor(state.size / flavours.length);
    const extra = state.size % flavours.length;
    return {size:state.size, quantities:Object.fromEntries(flavours.map((flavour, index) => [flavour.id, base + (index < extra ? 1 : 0)]))};
  };
  const applyEvenMix = mix => {
    if (busy || !mix || mix.size !== state.size || !flavours.every(flavour => Number.isInteger(mix.quantities[flavour.id]) && mix.quantities[flavour.id] >= 0 && mix.quantities[flavour.id] <= state.size) || flavours.reduce((sum, flavour) => sum + mix.quantities[flavour.id], 0) !== state.size) return;
    flavours.forEach(flavour => { state.quantities[flavour.id] = mix.quantities[flavour.id]; });
    showError(''); render(); toast(t('even_mix', {size:state.size}));
  };
  $('#pack-photo-open')?.addEventListener('click', () => { if (!busy) $('#pack-photo-dialog')?.showModal(); });
  $('#even-mix')?.addEventListener('click', () => {
    if (busy) return;
    const mix = calculateEvenMix();
    if (total() === 0) { applyEvenMix(mix); return; }
    openSummary(mix);
  });
  $('#confirm-remix')?.addEventListener('click', () => {
    if (busy || !validDraft()) return;
    flavours.forEach(flavour => { state.quantities[flavour.id] = pendingMix.quantities[flavour.id]; });
    showError(''); render();
    $('#checkout-box')?.focus({preventScroll:true});
  });
  $('#box-dialog')?.addEventListener('close', () => { pendingMix = null; render(); });
  $('#retry-stock')?.addEventListener('click', () => { if (!busy && $('#box-dialog')?.open) refreshStock(); });
  $('#c-country-form')?.addEventListener('submit', event => {
    const form = event.currentTarget;
    if (busy || region.malaysiaAvailable !== true || !$('#box-dialog')?.open || !validHandoffMix(state) || !validHandoffMix(pendingMix, true) || pendingMix.size !== state.size) { event.preventDefault(); return; }
    const notice = $('#c-region-error');
    if (notice) { notice.hidden = true; notice.textContent = ''; }
    try {
      const action = new URL(form.action, location.origin);
      if (action.origin !== location.origin || !action.pathname.endsWith('/localization') || !['lp-jeeroul-c','lp-jeeroul-c-en'].includes(config.landingView)) throw new Error('invalid_localization_form');
      const token = `${Date.now().toString(36)}-${Array.from(crypto.getRandomValues(new Uint32Array(2))).map(value => value.toString(36)).join('-')}`;
      const target = new URL(location.href);
      target.searchParams.set('view', config.landingView);
      target.searchParams.set('jrc_region_return', token);
      const returnInput = form.querySelector('[name="return_to"]');
      if (!returnInput || form.querySelector('[name="country_code"]')?.value !== 'MY') throw new Error('invalid_localization_form');
      const value = JSON.stringify({version:1, token, createdAt:Date.now(), productId:String(config.product.id), view:config.landingView, committed:copyMix(state), draft:copyMix(pendingMix)});
      sessionStorage.setItem(`${storageKey}:region_handoff`, value);
      if (sessionStorage.getItem(`${storageKey}:region_handoff`) !== value) throw new Error('handoff_not_saved');
      persistSelection();
      returnInput.value = target.pathname + target.search + target.hash;
      busy = true; stage = 'region_changing'; render();
      // The user's native form submission changes only Shopify localization.
    } catch {
      event.preventDefault();
      if (notice) { notice.textContent = t('region_save_failed'); notice.hidden = false; }
    }
  });
  $('#clear-mix')?.addEventListener('click', () => { if (!busy) { flavours.forEach(flavour => { state.quantities[flavour.id] = 0; }); showError(''); render(); } });
  $('#dialog-add')?.addEventListener('click', () => {
    if (!add(state.detail)) return;
    $('#flavour-dialog').close();
    $$('[data-minus]').find(element => element.dataset.minus === state.detail)?.focus({preventScroll:true});
    $('#build')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    toast(t('continue_mix'));
  });
  const renderDraft = () => {
    if (!pendingMix) return;
    const count = draftTotal();
    const remaining = pendingMix.size - count;
    $$('[data-draft-qty]').forEach(element => { element.textContent = pendingMix.quantities[element.dataset.draftQty]; });
    $$('[data-draft-minus]').forEach(element => { element.disabled = busy || pendingMix.quantities[element.dataset.draftMinus] === 0; });
    $$('[data-draft-add]').forEach(element => { element.disabled = busy || remaining <= 0; });
    const apply = $('#confirm-remix');
    if (apply) { apply.hidden = draftMatchesState(); apply.disabled = busy || !validDraft(); }
    const countLabel = $('#c-summary-count');
    if (countLabel) countLabel.textContent = t('draft_count', {count, size:pendingMix.size});
    const status = $('#c-summary-status');
    if (status) { status.textContent = remaining > 0 ? t('need_more', {count:remaining}) : remaining < 0 ? t('remove_extra', {count:-remaining}) : t('mix_complete'); status.dataset.complete = String(remaining === 0); }
    const saved = $('#c-summary-saved');
    if (saved) saved.textContent = draftMatchesState() && validDraft() ? (stockConfirmed() ? t('summary_saved') : '') : t('apply_first');
  };
  const openSummary = mix => {
    if (busy || !mix || mix.size !== state.size) return;
    pendingMix = {size:mix.size, quantities:{...mix.quantities}};
    $('#box-dialog-package').textContent = t('package_summary', {size:state.size});
    $('#box-dialog-items').innerHTML = flavours.map(flavour => `<li class="c-summary-flavour"><span>${escape(flavour.zh)}</span><div class="c-summary-stepper"><button type="button" data-draft-minus="${escape(flavour.id)}" aria-label="${escape(t('minus_label', {name:flavour.zh}))}">−</button><output data-draft-qty="${escape(flavour.id)}" aria-label="${escape(t('quantity_label', {name:flavour.zh}))}">${pendingMix.quantities[flavour.id]}</output><button type="button" data-draft-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></li>`).join('');
    showError(''); refreshStock(); $('#box-dialog').showModal();
    $('#box-dialog').scrollTop = 0;
  };
  const showBox = () => {
    if (busy || total() !== state.size) return;
    openSummary(state);
  };
  $('#review-box')?.addEventListener('click', showBox);
  $('#mobile-box')?.addEventListener('click', () => {
    if (busy) return;
    if (total() === state.size) showBox();
    else $('#build')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  $$('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }));
  const request = async (path, options = {}, timeout = 20000) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(`${rootUrl}${path}`, {...options, credentials:'same-origin', cache:'no-store', signal:controller.signal, headers:{Accept:'application/json', ...(options.headers || {})}});
      let data;
      try { data = await response.json(); } catch { throw new Error('invalid_response'); }
      return {response, data};
    } finally { clearTimeout(timer); }
  };
  const refreshStock = () => {
    // Sharing the in-flight request also covers closing and reopening the dialog.
    if (stockPromise) { render(); return stockPromise; }
    [12,20].forEach(size => { stockStates[size] = 'checking'; });
    render();
    stockPromise = Promise.resolve().then(async () => {
      if (!validId(config.product?.id) || typeof config.product?.handle !== 'string' || !config.product.handle.trim()) throw new Error('invalid_product');
      const {response, data} = await request(`products/${encodeURIComponent(config.product.handle)}.js`, {}, 8000);
      if (!response.ok || !validId(data?.id) || String(data.id) !== String(config.product.id) || !Array.isArray(data.variants)) throw new Error('wrong_product');
      [12,20].forEach(size => {
        const pack = packages[size];
        const matches = data.variants.filter(variant => validId(variant?.id) && String(variant.id) === String(pack.id));
        const variant = matches[0];
        stockStates[size] = !validPackage(pack) || matches.length !== 1 || typeof variant.available !== 'boolean' || !Number.isSafeInteger(variant.price) || variant.price <= 0
          ? 'error' : variant.price !== pack.price ? 'price_changed' : variant.available ? 'available' : 'sold_out';
      });
    }).catch(() => {
      [12,20].forEach(size => { stockStates[size] = 'error'; });
    }).finally(() => {
      stockPromise = null;
      // No focus changes or checkout-error writes: a closed dialog stays closed.
      render();
    });
    return stockPromise;
  };
  const reconcile = async pending => {
    stage = 'checking'; render();
    const {response, data} = await request('cart.js');
    if (!response.ok || !Array.isArray(data.items)) throw new Error('cart_unavailable');
    $$('[data-cart-count]').forEach(element => { element.textContent = data.item_count; });
    const items = data.items.filter(item => item.properties?._jrc_attempt === pending.id);
    if (!items.length) return 'missing';
    if (items.length !== 1 || String(items[0].variant_id || items[0].id) !== String(pending.variantId) || items[0].quantity !== 1 || items[0].properties?.['Flavour mix'] !== pending.mix) return 'changed';
    return 'found';
  };
  const makeAttempt = () => {
    const random = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now().toString(36)}-${Array.from(crypto.getRandomValues(new Uint32Array(3))).map(value => value.toString(36)).join('-')}`;
    return {id:random, signature:signature(), variantId:String(selectedPackage().id), mix:mixText(), status:'adding', createdAt:Date.now()};
  };
  const makeProperties = pending => {
    const properties = {'Flavour mix':pending.mix, _landing_page:config.landingId || 'lp-jeeroul-c', _jrc_attempt:pending.id};
    const params = new URLSearchParams(location.search);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key => {
      const value = params.get(key);
      if (value) properties[`_${key}`] = value.replace(/[\u0000-\u001F\u007F]/g, '').slice(0, 150);
    });
    return properties;
  };
  const goCheckout = () => {
    stage = 'redirecting'; navigating = true; render();
    const form = document.createElement('form');
    form.method = 'post'; form.action = cartUrl; form.hidden = true;
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = 'checkout'; input.value = '1';
    form.append(input); document.body.append(form);
    clearTimeout(navigationTimer);
    navigationTimer = setTimeout(() => {
      if (!navigating) return;
      navigating = false; busy = false; stage = ''; form.remove();
      showError(t(location.hostname.endsWith('.shopifypreview.com') ? 'preview_checkout' : 'checkout_stalled')); render();
    }, 12000);
    try { HTMLFormElement.prototype.submit.call(form); } catch { location.assign(checkoutUrl); }
  };
  const ensureMainBox = async () => {
    showError('');
    if (total() !== state.size) { showError(t('invalid_mix', {size:state.size})); return; }
    if (!stockConfirmed()) { showError(stockMessage(stockStates[state.size]) || t('stock_error')); return; }
    if (attempt) {
      let result;
      try { result = await reconcile(attempt); } catch { showError(t('uncertain')); return; }
      if (result === 'changed') { showError(t('changed_cart')); return; }
      if (result === 'found') {
        attempt.status = 'added'; persistAttempt();
        if (attempt.signature === signature()) { return true; }
        showError(t('changed_cart')); return;
      } else if (attempt.status !== 'added') {
        attempt.status = 'uncertain'; persistAttempt(); showError(t('uncertain_not_found')); return;
      }
    }
    attempt = makeAttempt(); persistAttempt();
    stage = 'adding'; render();
    try {
      const {response, data} = await request('cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:attempt.variantId, quantity:1, properties:makeProperties(attempt)}]})});
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) { attempt = null; persistAttempt(); showError(t('add_failed')); return; }
        throw new Error('uncertain_add');
      }
      const items = Array.isArray(data.items) ? data.items : [data];
      const added = items.find(item => item.properties?._jrc_attempt === attempt.id);
      if (!added || String(added.variant_id || added.id) !== attempt.variantId || added.quantity !== 1 || added.properties?.['Flavour mix'] !== attempt.mix) throw new Error('unconfirmed_add');
      attempt.status = 'added'; persistAttempt(); return true;
    } catch {
      attempt.status = 'uncertain'; persistAttempt();
      try {
        const result = await reconcile(attempt);
        if (result === 'found') { attempt.status = 'added'; persistAttempt(); return true; }
        showError(t(result === 'changed' ? 'changed_cart' : 'uncertain'));
      } catch { showError(t('uncertain')); }
    }
  };
  // The main-box attempt remains independent from the optional PWP transaction.
  const performCheckout = async () => {
    const pwp = window.JeeroulPwp;
    let pwpConfig = pwp?.config;
    if (!pwpConfig) { try { pwpConfig = JSON.parse(document.getElementById('jr-pwp-config')?.textContent || 'null'); } catch {} }
    const pwpActive = pwpConfig?.enabled === true && Date.now() >= Date.parse(pwpConfig.startsAt) && Date.now() <= Date.parse(pwpConfig.endsAt);
    if (pwpActive && pwpConfig?.previewOnly !== true && (typeof pwp?.beforeCheckout !== 'function' || typeof pwp?.preflightCheckout !== 'function')) {
      showError(String(config.locale || '').startsWith('zh') ? '加购功能尚未准备好，请刷新页面。' : 'The add-on feature is not ready. Please refresh this page.');
      return;
    }
    if (pwpConfig?.previewOnly === true) {
      const result = {ready:false,error:'preview',canSkip:true,message:String(config.locale || '').startsWith('zh') ? '这是优惠预览。优惠券尚未启用，不会加入加购商品。' : 'This is an offer preview. The voucher is not active and no add-on will be added.'};
      pwp.showCartError?.(result); showError(result.message); return;
    }
    // Pure validation precedes the main POST; an opted-in but incomplete pair cannot add a box.
    if (typeof pwp?.preflightCheckout === 'function') {
      const check = pwp.preflightCheckout({language:config.locale || 'en'});
      if (!check?.ready) { pwp.showCartError?.(check); showError(check?.message || (String(config.locale || '').startsWith('zh') ? '请先选满两片加购。' : 'Choose both add-on pieces first.')); return; }
    }
    if (!await ensureMainBox()) return;
    // Outside the main POST catch: a PWP failure must not mark the main box uncertain.
    if (typeof pwp?.beforeCheckout === 'function') {
      const result = await pwp.beforeCheckout({root:rootUrl, language:config.locale || 'en'});
      if (!result?.ready) {
        pwp.showCartError?.(result || {error:'cart',canSkip:false});
        showError(result?.message || (String(config.locale || '').startsWith('zh') ? '尚未确认加购，请检查购物车。' : 'The add-on has not been confirmed. Please review your cart.'));
        return;
      }
    }
    pwp?.markCheckoutStarted?.();
    goCheckout();
  };
  $('#checkout-box')?.addEventListener('click', event => {
    event.preventDefault();
    if (busy || checkoutPromise) return;
    if (!validDraft() || !draftMatchesState()) { showError(t('apply_first')); return; }
    busy = true; stage = 'adding'; render();
    checkoutPromise = performCheckout().catch(() => { showError(t('uncertain')); }).finally(() => {
      checkoutPromise = null;
      if (!navigating) { busy = false; stage = ''; render(); }
    });
  });
  window.addEventListener('pageshow', () => { clearTimeout(navigationTimer); busy = false; navigating = false; checkoutPromise = null; stage = ''; render(); });
  render();
  if (restoredDraft) openSummary(restoredDraft);
  else if ([12,20].some(size => ['sold_out','error'].includes(stockStates[size]))) refreshStock();
})();


(() => {
  if (!document.body.classList.contains('jeeroul-landing-c')) return;
  // Shopping prices enter the experience with the box builder, including on return visits.
  const build = document.getElementById('build');
  const shoppingBar = document.querySelector('.mobile-bar');
  let shoppingFrame = 0;
  const updateShoppingBar = () => {
    shoppingFrame = 0;
    const show = !!build && build.getBoundingClientRect().top <= innerHeight * 0.65;
    document.body.classList.toggle('c-mobile-shopping', show);
    if (shoppingBar) shoppingBar.hidden = !show;
  };
  const scheduleShoppingBar = () => {
    if (!shoppingFrame) shoppingFrame = requestAnimationFrame(updateShoppingBar);
  };
  updateShoppingBar();
  addEventListener('scroll', scheduleShoppingBar, {passive: true});
  addEventListener('resize', scheduleShoppingBar, {passive: true});
  addEventListener('pageshow', scheduleShoppingBar);
  addEventListener('load', scheduleShoppingBar, {once: true});
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleShoppingBar);
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const elements = [...document.querySelectorAll('.c-reveal')];
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('c-visible'); observer.unobserve(entry.target); }
    });
  }, {rootMargin: '0px 0px 70px 0px', threshold: 0.05});
  elements.forEach(element => {
    if (element.getBoundingClientRect().top < innerHeight) element.classList.add('c-visible');
    observer.observe(element);
  });
  document.body.classList.add('c-motion-ready');
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-jeeroul-c"]) return;
  try {
    
(() => {
  'use strict';
  const configNode = document.getElementById('jrc-config');
  if (!configNode || configNode.dataset.initialized === 'true') return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  // Liquid's translation filter HTML-escapes text before JSON serialization.
  const decodeText = value => String(value ?? '').replace(/&(amp|lt|gt|quot|#39|#x27);/g, (match, entity) => ({amp:'&', lt:'<', gt:'>', quot:'"', '#39':"'", '#x27':"'"}[entity]));
  const flavours = Array.isArray(config.flavours) ? config.flavours.map(flavour => ({...flavour, zh:decodeText(flavour.zh), en:decodeText(flavour.en), short:decodeText(flavour.short), description:decodeText(flavour.description)})) : [];
  const packages = config.packages || {};
  if (!flavours.length || !packages[12] || !packages[20]) return;
  configNode.dataset.initialized = 'true';
  const $ = selector => document.querySelector(selector);
  const $$ = selector => [...document.querySelectorAll(selector)];
  const strings = config.strings || {};
  const t = (key, values = {}) => decodeText(strings[key === 'pack_quantity' && values.count === 1 ? 'pack_quantity_one' : key] || strings[key] || key).replace(/\{(\w+)\}/g, (match, name) => values[name] == null ? match : String(values[name]));
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[character]));
  const arrow = '<svg aria-hidden="true"><use href="#arrow"/></svg>';
  const mobileBuildLabel = $('#mobile-box')?.textContent.trim() || '';
  // Change only the alternate view; retain advertising parameters and page position.
  const updateLanguageLinks = () => $$('[data-language-view]').forEach(link => {
    const url = new URL(location.href);
    url.searchParams.set('view', link.dataset.languageView);
    link.href = url.href;
  });
  updateLanguageLinks();
  window.addEventListener('hashchange', updateLanguageLinks);

  const storageKey = `jeeroul:${config.landingId || 'lp-jeeroul-c'}:${config.product?.id || ''}`;
  const readStored = suffix => { try { return JSON.parse(sessionStorage.getItem(`${storageKey}:${suffix}`)); } catch { return null; } };
  const saveStored = (suffix, value) => { try { sessionStorage.setItem(`${storageKey}:${suffix}`, JSON.stringify(value)); } catch {} };
  const safeLocal = (value, fallback) => { try { const url = new URL(value || fallback, location.origin); return url.origin === location.origin ? url.pathname + url.search : fallback; } catch { return fallback; } };
  let rootUrl = safeLocal(window.Shopify?.routes?.root || config.rootUrl, '/');
  if (!rootUrl.endsWith('/')) rootUrl += '/';
  const cartUrl = safeLocal(config.cartUrl, `${rootUrl}cart`);
  const checkoutUrl = safeLocal(config.checkoutUrl, `${rootUrl}checkout`);
  const region = config.localization || {};
  const copyMix = mix => ({size:mix.size, quantities:{...mix.quantities}});
  const validHandoffMix = (mix, draft = false) => mix && [12,20].includes(mix.size) && mix.quantities && Object.keys(mix.quantities).length === flavours.length && flavours.every(flavour => Number.isInteger(mix.quantities[flavour.id]) && mix.quantities[flavour.id] >= 0 && mix.quantities[flavour.id] <= (draft ? mix.size : 20)) && flavours.reduce((sum, flavour) => sum + mix.quantities[flavour.id], 0) <= (draft ? mix.size : 20);
  const state = {size:12, quantities:Object.fromEntries(flavours.map(flavour => [flavour.id, 0])), detail:null};
  const saved = readStored('selection');
  if (saved && [12,20].includes(saved.size)) {
    state.size = saved.size;
    flavours.forEach(flavour => {
      const value = saved.quantities?.[flavour.id];
      state.quantities[flavour.id] = Number.isInteger(value) && value >= 0 && value <= 20 ? value : 0;
    });
  }
  // A country change keeps committed choices and the unsaved draft separate.
  // Consume only this tab's short-lived handoff, never selections supplied in a URL.
  const handoff = readStored('region_handoff');
  const returnUrl = new URL(location.href);
  const regionToken = returnUrl.searchParams.get('jrc_region_return');
  let restoredDraft = null;
  if (regionToken) {
    const age = Date.now() - handoff?.createdAt;
    if (handoff?.version === 1 && handoff.token === regionToken && /^[a-zA-Z0-9_-]{8,100}$/.test(regionToken) && Number.isFinite(handoff.createdAt) && Number.isFinite(age) && age >= 0 && age <= 600000 && handoff.productId === String(config.product?.id) && handoff.view === config.landingView && returnUrl.searchParams.get('view') === config.landingView && validHandoffMix(handoff.committed) && validHandoffMix(handoff.draft, true) && handoff.draft.size === handoff.committed.size) {
      state.size = handoff.committed.size;
      state.quantities = {...handoff.committed.quantities};
      restoredDraft = copyMix(handoff.draft);
    }
    try { sessionStorage.removeItem(`${storageKey}:region_handoff`); } catch {}
    returnUrl.searchParams.delete('jrc_region_return');
    try { history.replaceState(history.state, '', returnUrl.pathname + returnUrl.search + returnUrl.hash); } catch {}
    updateLanguageLinks();
  } else if (handoff && (!Number.isFinite(handoff.createdAt) || Date.now() - handoff.createdAt > 600000)) {
    try { sessionStorage.removeItem(`${storageKey}:region_handoff`); } catch {}
  }
  let attempt = readStored('attempt');
  if (!attempt || !/^[a-zA-Z0-9_-]{8,100}$/.test(attempt.id || '') || !['adding','uncertain','added'].includes(attempt.status)) attempt = null;
  let busy = false;
  let navigating = false;
  let checkoutPromise = null;
  let stage = '';
  let toastTimer;
  let pendingMix = null;
  let navigationTimer;
  const draftTotal = () => pendingMix ? flavours.reduce((sum, flavour) => sum + pendingMix.quantities[flavour.id], 0) : 0;
  const validDraft = () => pendingMix && pendingMix.size === state.size && flavours.every(flavour => Number.isInteger(pendingMix.quantities[flavour.id]) && pendingMix.quantities[flavour.id] >= 0 && pendingMix.quantities[flavour.id] <= state.size) && draftTotal() === state.size;
  const draftMatchesState = () => pendingMix && pendingMix.size === state.size && flavours.every(flavour => pendingMix.quantities[flavour.id] === state.quantities[flavour.id]);
  const total = () => flavours.reduce((sum, flavour) => sum + state.quantities[flavour.id], 0);
  const selectedPackage = () => packages[state.size];
  const validId = value => (typeof value === 'string' || (typeof value === 'number' && Number.isSafeInteger(value))) && /^[1-9]\d*$/.test(String(value));
  const validPackage = pack => pack && validId(pack.id) && Number.isSafeInteger(pack.price) && pack.price > 0;
  // Keep the displayed variant and price immutable; a read-only check confirms that exact offer.
  const stockStates = Object.fromEntries([12,20].map(size => {
    const pack = packages[size];
    return [size, !validPackage(pack) || typeof pack.available !== 'boolean' ? 'error' : pack.available ? 'unverified' : 'sold_out'];
  }));
  let stockPromise = null;
  const stockMessage = status => {
    const key = {checking:'stock_checking', sold_out:'stock_sold_out', error:'stock_error', price_changed:'stock_price_changed'}[status];
    return key ? t(key) : '';
  };
  const stockConfirmed = () => stockStates[state.size] === 'available' && validPackage(selectedPackage());
  const signature = () => JSON.stringify([String(selectedPackage().id), state.size, flavours.map(flavour => state.quantities[flavour.id])]);
  const money = cents => {
    const value = Number(cents) / 100;
    if (config.currency === 'MYR') return `RM${value.toLocaleString(config.locale || 'zh-CN', {minimumFractionDigits:Number.isInteger(value) ? 0 : 2, maximumFractionDigits:2})}`;
    return new Intl.NumberFormat(config.locale || 'zh-CN', {style:'currency', currency:config.currency || 'MYR'}).format(value);
  };
  const mixText = () => flavours.filter(flavour => state.quantities[flavour.id] > 0).map(flavour => `${flavour.fulfilmentName || flavour.en} x ${state.quantities[flavour.id]}`).join(', ');
  const persistSelection = () => saveStored('selection', {size:state.size, quantities:state.quantities});
  const persistAttempt = () => saveStored('attempt', attempt);
  const toast = text => {
    const element = $('#toast');
    if (!element) return;
    element.textContent = text;
    element.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => element.classList.remove('show'), 3500);
  };
  const showError = message => {
    const element = $('#checkout-error');
    if (!element) return;
    element.textContent = message || '';
    element.hidden = !message;
    if (message) { element.setAttribute('tabindex', '-1'); element.focus({preventScroll:true}); }
  };
  const flavourGrid = $('#flavour-grid');
  const mixList = $('#mix-list');
  if (flavourGrid && !flavourGrid.querySelector('.flavour-card')) flavourGrid.innerHTML = flavours.map(flavour => `<article class="flavour-card"><button type="button" class="flavour-image" data-detail="${escape(flavour.id)}" aria-label="${escape(t('photo_label', {name:flavour.zh, energy:flavour.energy}))}"><img src="${escape(flavour.image)}" width="1080" height="1350" loading="lazy" alt="${escape(t('photo_alt', {english:flavour.en, name:flavour.zh, energy:flavour.energy}))}"><span class="zoom-label" aria-hidden="true">+</span></button><div class="flavour-card-bottom"><div><h3>${escape(flavour.zh)}</h3><p class="flavour-card-en" lang="en">${escape(flavour.en)}</p><p>${escape(flavour.short)}</p></div><button type="button" class="flavour-add" data-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></article>`).join('');
  if (mixList && !mixList.querySelector('.mix-row')) mixList.innerHTML = flavours.map(flavour => `<div class="mix-row"><button type="button" class="mix-thumb" data-detail="${escape(flavour.id)}" aria-label="${escape(t('detail_label', {name:flavour.zh}))}"><img src="${escape(flavour.image)}" alt="${escape(flavour.zh)}" width="1080" height="1350" loading="lazy"></button><div class="mix-name"><h3>${escape(flavour.zh)}</h3><p>${escape(flavour.en)}</p></div><div class="stepper"><button type="button" data-minus="${escape(flavour.id)}" aria-label="${escape(t('minus_label', {name:flavour.zh}))}">−</button><output data-qty="${escape(flavour.id)}" aria-label="${escape(t('quantity_label', {name:flavour.zh}))}">0</output><button type="button" data-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></div>`).join('');
  $$('[data-package-price]').forEach(element => { const pack = packages[element.dataset.packagePrice]; if (pack) element.textContent = money(pack.price); });
  $$('[data-package-per-pack]').forEach(element => { const size = Number(element.dataset.packagePerPack); if (packages[size]) element.textContent = t('per_pack', {price:money(packages[size].price / size)}); });
  const availablePackages = [12,20].filter(size => validPackage(packages[size]) && packages[size].available === true);
  if (availablePackages.length) $$('[data-from-price]').forEach(element => { element.textContent = money(Math.min(...availablePackages.map(size => packages[size].price / size))); });
  $$('[data-view-cart], #view-cart').forEach(element => { element.href = cartUrl; });
  const updateWhatsApp = () => {
    if (!config.whatsappUrl) return;
    try {
      const url = new URL(config.whatsappUrl);
      if (!['wa.me','api.whatsapp.com','web.whatsapp.com'].includes(url.hostname) || url.protocol !== 'https:') return;
      url.searchParams.set('text', t('whatsapp_message', {size:state.size, mix:mixText() || t('no_mix')}));
      $$('#contact-whatsapp, [data-contact-whatsapp]').forEach(element => { element.href = url.href; });
    } catch {}
  };
  let pwpPackageSignature = '';
  const publishPwpPackage = (force = false) => {
    const detail = {size:state.size,price:selectedPackage().price,currency:config.currency || 'MYR'};
    const next = JSON.stringify(detail);
    if (force || next !== pwpPackageSignature) {
      pwpPackageSignature = next;
      document.dispatchEvent(new CustomEvent('jeeroul:package-change',{detail,bubbles:true}));
    }
  };
  window.addEventListener('jeeroul:pwp-ready', () => publishPwpPackage(true));
  const render = () => {
    window.JeeroulPwp?.setBusy?.(busy);
    publishPwpPackage();
    const count = total();
    const remaining = state.size - count;
    const stockStatus = stockStates[state.size];
    const available = stockConfirmed();
    $$('[data-count]').forEach(element => { element.textContent = count; });
    $$('[data-size-label]').forEach(element => { element.textContent = state.size; });
    $$('[data-price]').forEach(element => { element.textContent = money(selectedPackage().price); });
    $$('[data-size]').forEach(element => {
      const size = Number(element.dataset.size);
      element.setAttribute('aria-pressed', String(size === state.size));
      element.disabled = busy;
      element.classList.toggle('is-unavailable', ['sold_out','error','price_changed'].includes(stockStates[size]));
      const status = element.querySelector('[data-package-status]');
      if (status) status.textContent = stockStates[size] === 'sold_out' ? t('sold_out') : stockStates[size] === 'checking' ? t('stock_checking') : ['error','price_changed'].includes(stockStates[size]) ? t('stock_unconfirmed') : '';
    });
    $$('[data-qty]').forEach(element => { element.textContent = state.quantities[element.dataset.qty]; });
    $$('[data-minus]').forEach(element => { element.disabled = busy || state.quantities[element.dataset.minus] === 0; });
    $$('[data-add]').forEach(element => { element.disabled = busy || remaining <= 0; });
    ['#even-mix','#clear-mix'].forEach(selector => { if ($(selector)) $(selector).disabled = busy; });
    const cProgress = $('#c-selection-progress');
    if (cProgress) { cProgress.style.width = `${Math.min(100, count / state.size * 100)}%`; cProgress.setAttribute('aria-valuemax', state.size); cProgress.setAttribute('aria-valuenow', Math.min(count, state.size)); }
    const progress = $('#mix-progress');
    if (progress) { progress.max = state.size; progress.value = Math.min(count, state.size); }
    if ($('[data-percent]')) $('[data-percent]').textContent = `${Math.round(count / state.size * 100)}%`;
    const status = $('#mix-status');
    if (status) { status.textContent = remaining > 0 ? t('need_more', {count:remaining}) : remaining < 0 ? t('remove_extra', {count:-remaining}) : t('mix_complete'); status.style.color = remaining < 0 ? '#a64224' : ''; }
    const review = $('#review-box');
    if (review) {
      review.disabled = busy || remaining !== 0;
      review.innerHTML = escape(remaining > 0 ? t('need_more_short', {count:remaining}) : remaining < 0 ? t('remove_extra_short', {count:-remaining}) : t('review_mix')) + arrow;
    }
    const mobileReview = $('#mobile-box');
    if (mobileReview) {
      const ready = remaining === 0;
      mobileReview.disabled = busy;
      mobileReview.innerHTML = escape(ready ? t('review_mix') : mobileBuildLabel) + arrow;
      mobileReview.setAttribute('aria-controls', ready ? 'box-dialog' : 'build');
      if (ready) mobileReview.setAttribute('aria-haspopup', 'dialog');
      else mobileReview.removeAttribute('aria-haspopup');
    }
    const checkout = $('#checkout-box');
    if (checkout) {
      const matchesAttempt = attempt?.signature === signature();
      const label = busy ? t(stage || 'adding') : matchesAttempt && attempt.status === 'added' ? t('continue_checkout') : attempt && ['adding','uncertain'].includes(attempt.status) ? t('check_cart') : t('checkout');
      checkout.textContent = stockStatus === 'sold_out' ? t('sold_out') : stockStatus === 'checking' ? t('stock_checking') : label;
      checkout.disabled = busy || remaining !== 0 || !available || !validDraft() || !draftMatchesState();
      checkout.setAttribute('aria-busy', String(busy || stockStatus === 'checking'));
    }
    const stockNotice = $('#c-stock-status');
    if (stockNotice) { stockNotice.textContent = stockMessage(stockStatus); stockNotice.hidden = !stockNotice.textContent; stockNotice.dataset.state = stockStatus; }
    const retryStock = $('#retry-stock');
    if (retryStock) { retryStock.hidden = ['unverified','available'].includes(stockStatus); retryStock.disabled = busy || stockStatus === 'checking'; }
    const otherCountry = !!region.countryCode && region.countryCode !== 'MY';
    const needsRegionHelp = otherCountry || ['sold_out','error'].includes(stockStatus);
    const regionNote = $('#c-region-note');
    if (regionNote) { regionNote.hidden = !needsRegionHelp; regionNote.textContent = needsRegionHelp ? t(otherCountry ? 'region_delivery_note' : 'region_recheck_note') : ''; }
    const recovery = $('#c-region-recovery');
    if (recovery) recovery.hidden = region.malaysiaAvailable !== true || !needsRegionHelp;
    const countryButton = $('#c-deliver-malaysia');
    if (countryButton) countryButton.disabled = busy;
    const dialogAdd = $('#dialog-add');
    if (dialogAdd) dialogAdd.disabled = busy || remaining <= 0;
    const feedback = $('#dialog-feedback');
    if (feedback) feedback.textContent = remaining < 0 ? t('box_over', {total:count, count:-remaining}) : remaining === 0 ? t('dialog_full') : '';
    renderDraft();
    updateWhatsApp();
    persistSelection();
  };
  const add = (id, notify = false) => {
    const flavour = flavours.find(item => item.id === id);
    if (busy || !flavour) return false;
    if (total() >= state.size) { toast(total() > state.size ? t('box_over', {total:total(), count:total()-state.size}) : t('box_full', {size:state.size})); return false; }
    state.quantities[id] += 1;
    showError('');
    render();
    if (notify) toast(t('added_flavour', {name:flavour.zh, total:total(), size:state.size}));
    return true;
  };
  const showFlavour = id => {
    const flavour = flavours.find(item => item.id === id);
    const dialog = $('#flavour-dialog');
    if (!flavour || !dialog) return;
    state.detail = id;
    $('#flavour-dialog-title').textContent = flavour.zh;
    $('#flavour-dialog-en').textContent = flavour.en;
    $('#flavour-dialog-description').textContent = flavour.description;
    $('#flavour-dialog-energy').textContent = flavour.energy;
    $('#flavour-dialog-image').src = flavour.image;
    $('#flavour-dialog-image').alt = t('photo_alt', {english:flavour.en, name:flavour.zh, energy:flavour.energy});
    render();
    dialog.showModal();
    dialog.scrollTop = 0;
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const detail = event.target.closest('[data-detail]');
    const plus = event.target.closest('[data-add]');
    const minus = event.target.closest('[data-minus]');
    const size = event.target.closest('[data-size]');
    const close = event.target.closest('[data-close]');
    const draftPlus = event.target.closest('[data-draft-add]');
    const draftMinus = event.target.closest('[data-draft-minus]');
    if ((draftPlus || draftMinus) && !busy && pendingMix && $('#box-dialog')?.open) {
      const id = draftPlus ? draftPlus.dataset.draftAdd : draftMinus.dataset.draftMinus;
      if (!Object.hasOwn(pendingMix.quantities, id)) return;
      if (draftPlus && draftTotal() < pendingMix.size) pendingMix.quantities[id] += 1;
      if (draftMinus) pendingMix.quantities[id] = Math.max(0, pendingMix.quantities[id] - 1);
      showError(''); render();
      return;
    }
    if (detail) showFlavour(detail.dataset.detail);
    if (plus) add(plus.dataset.add, !plus.closest('.stepper'));
    if (minus && !busy && Object.hasOwn(state.quantities, minus.dataset.minus)) { state.quantities[minus.dataset.minus] = Math.max(0, state.quantities[minus.dataset.minus] - 1); showError(''); render(); }
    if (size && !busy && [12,20].includes(Number(size.dataset.size))) { state.size = Number(size.dataset.size); showError(''); render(); }
    if (close) close.closest('dialog')?.close();
  });
  const calculateEvenMix = () => {
    const base = Math.floor(state.size / flavours.length);
    const extra = state.size % flavours.length;
    return {size:state.size, quantities:Object.fromEntries(flavours.map((flavour, index) => [flavour.id, base + (index < extra ? 1 : 0)]))};
  };
  const applyEvenMix = mix => {
    if (busy || !mix || mix.size !== state.size || !flavours.every(flavour => Number.isInteger(mix.quantities[flavour.id]) && mix.quantities[flavour.id] >= 0 && mix.quantities[flavour.id] <= state.size) || flavours.reduce((sum, flavour) => sum + mix.quantities[flavour.id], 0) !== state.size) return;
    flavours.forEach(flavour => { state.quantities[flavour.id] = mix.quantities[flavour.id]; });
    showError(''); render(); toast(t('even_mix', {size:state.size}));
  };
  $('#pack-photo-open')?.addEventListener('click', () => { if (!busy) $('#pack-photo-dialog')?.showModal(); });
  $('#even-mix')?.addEventListener('click', () => {
    if (busy) return;
    const mix = calculateEvenMix();
    if (total() === 0) { applyEvenMix(mix); return; }
    openSummary(mix);
  });
  $('#confirm-remix')?.addEventListener('click', () => {
    if (busy || !validDraft()) return;
    flavours.forEach(flavour => { state.quantities[flavour.id] = pendingMix.quantities[flavour.id]; });
    showError(''); render();
    $('#checkout-box')?.focus({preventScroll:true});
  });
  $('#box-dialog')?.addEventListener('close', () => { pendingMix = null; render(); });
  $('#retry-stock')?.addEventListener('click', () => { if (!busy && $('#box-dialog')?.open) refreshStock(); });
  $('#c-country-form')?.addEventListener('submit', event => {
    const form = event.currentTarget;
    if (busy || region.malaysiaAvailable !== true || !$('#box-dialog')?.open || !validHandoffMix(state) || !validHandoffMix(pendingMix, true) || pendingMix.size !== state.size) { event.preventDefault(); return; }
    const notice = $('#c-region-error');
    if (notice) { notice.hidden = true; notice.textContent = ''; }
    try {
      const action = new URL(form.action, location.origin);
      if (action.origin !== location.origin || !action.pathname.endsWith('/localization') || !['lp-jeeroul-c','lp-jeeroul-c-en'].includes(config.landingView)) throw new Error('invalid_localization_form');
      const token = `${Date.now().toString(36)}-${Array.from(crypto.getRandomValues(new Uint32Array(2))).map(value => value.toString(36)).join('-')}`;
      const target = new URL(location.href);
      target.searchParams.set('view', config.landingView);
      target.searchParams.set('jrc_region_return', token);
      const returnInput = form.querySelector('[name="return_to"]');
      if (!returnInput || form.querySelector('[name="country_code"]')?.value !== 'MY') throw new Error('invalid_localization_form');
      const value = JSON.stringify({version:1, token, createdAt:Date.now(), productId:String(config.product.id), view:config.landingView, committed:copyMix(state), draft:copyMix(pendingMix)});
      sessionStorage.setItem(`${storageKey}:region_handoff`, value);
      if (sessionStorage.getItem(`${storageKey}:region_handoff`) !== value) throw new Error('handoff_not_saved');
      persistSelection();
      returnInput.value = target.pathname + target.search + target.hash;
      busy = true; stage = 'region_changing'; render();
      // The user's native form submission changes only Shopify localization.
    } catch {
      event.preventDefault();
      if (notice) { notice.textContent = t('region_save_failed'); notice.hidden = false; }
    }
  });
  $('#clear-mix')?.addEventListener('click', () => { if (!busy) { flavours.forEach(flavour => { state.quantities[flavour.id] = 0; }); showError(''); render(); } });
  $('#dialog-add')?.addEventListener('click', () => {
    if (!add(state.detail)) return;
    $('#flavour-dialog').close();
    $$('[data-minus]').find(element => element.dataset.minus === state.detail)?.focus({preventScroll:true});
    $('#build')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    toast(t('continue_mix'));
  });
  const renderDraft = () => {
    if (!pendingMix) return;
    const count = draftTotal();
    const remaining = pendingMix.size - count;
    $$('[data-draft-qty]').forEach(element => { element.textContent = pendingMix.quantities[element.dataset.draftQty]; });
    $$('[data-draft-minus]').forEach(element => { element.disabled = busy || pendingMix.quantities[element.dataset.draftMinus] === 0; });
    $$('[data-draft-add]').forEach(element => { element.disabled = busy || remaining <= 0; });
    const apply = $('#confirm-remix');
    if (apply) { apply.hidden = draftMatchesState(); apply.disabled = busy || !validDraft(); }
    const countLabel = $('#c-summary-count');
    if (countLabel) countLabel.textContent = t('draft_count', {count, size:pendingMix.size});
    const status = $('#c-summary-status');
    if (status) { status.textContent = remaining > 0 ? t('need_more', {count:remaining}) : remaining < 0 ? t('remove_extra', {count:-remaining}) : t('mix_complete'); status.dataset.complete = String(remaining === 0); }
    const saved = $('#c-summary-saved');
    if (saved) saved.textContent = draftMatchesState() && validDraft() ? (stockConfirmed() ? t('summary_saved') : '') : t('apply_first');
  };
  const openSummary = mix => {
    if (busy || !mix || mix.size !== state.size) return;
    pendingMix = {size:mix.size, quantities:{...mix.quantities}};
    $('#box-dialog-package').textContent = t('package_summary', {size:state.size});
    $('#box-dialog-items').innerHTML = flavours.map(flavour => `<li class="c-summary-flavour"><span>${escape(flavour.zh)}</span><div class="c-summary-stepper"><button type="button" data-draft-minus="${escape(flavour.id)}" aria-label="${escape(t('minus_label', {name:flavour.zh}))}">−</button><output data-draft-qty="${escape(flavour.id)}" aria-label="${escape(t('quantity_label', {name:flavour.zh}))}">${pendingMix.quantities[flavour.id]}</output><button type="button" data-draft-add="${escape(flavour.id)}" aria-label="${escape(t('add_label', {name:flavour.zh}))}">+</button></div></li>`).join('');
    showError(''); refreshStock(); $('#box-dialog').showModal();
    $('#box-dialog').scrollTop = 0;
  };
  const showBox = () => {
    if (busy || total() !== state.size) return;
    openSummary(state);
  };
  $('#review-box')?.addEventListener('click', showBox);
  $('#mobile-box')?.addEventListener('click', () => {
    if (busy) return;
    if (total() === state.size) showBox();
    else $('#build')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  $$('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }));
  const request = async (path, options = {}, timeout = 20000) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(`${rootUrl}${path}`, {...options, credentials:'same-origin', cache:'no-store', signal:controller.signal, headers:{Accept:'application/json', ...(options.headers || {})}});
      let data;
      try { data = await response.json(); } catch { throw new Error('invalid_response'); }
      return {response, data};
    } finally { clearTimeout(timer); }
  };
  const refreshStock = () => {
    // Sharing the in-flight request also covers closing and reopening the dialog.
    if (stockPromise) { render(); return stockPromise; }
    [12,20].forEach(size => { stockStates[size] = 'checking'; });
    render();
    stockPromise = Promise.resolve().then(async () => {
      if (!validId(config.product?.id) || typeof config.product?.handle !== 'string' || !config.product.handle.trim()) throw new Error('invalid_product');
      const {response, data} = await request(`products/${encodeURIComponent(config.product.handle)}.js`, {}, 8000);
      if (!response.ok || !validId(data?.id) || String(data.id) !== String(config.product.id) || !Array.isArray(data.variants)) throw new Error('wrong_product');
      [12,20].forEach(size => {
        const pack = packages[size];
        const matches = data.variants.filter(variant => validId(variant?.id) && String(variant.id) === String(pack.id));
        const variant = matches[0];
        stockStates[size] = !validPackage(pack) || matches.length !== 1 || typeof variant.available !== 'boolean' || !Number.isSafeInteger(variant.price) || variant.price <= 0
          ? 'error' : variant.price !== pack.price ? 'price_changed' : variant.available ? 'available' : 'sold_out';
      });
    }).catch(() => {
      [12,20].forEach(size => { stockStates[size] = 'error'; });
    }).finally(() => {
      stockPromise = null;
      // No focus changes or checkout-error writes: a closed dialog stays closed.
      render();
    });
    return stockPromise;
  };
  const reconcile = async pending => {
    stage = 'checking'; render();
    const {response, data} = await request('cart.js');
    if (!response.ok || !Array.isArray(data.items)) throw new Error('cart_unavailable');
    $$('[data-cart-count]').forEach(element => { element.textContent = data.item_count; });
    const items = data.items.filter(item => item.properties?._jrc_attempt === pending.id);
    if (!items.length) return 'missing';
    if (items.length !== 1 || String(items[0].variant_id || items[0].id) !== String(pending.variantId) || items[0].quantity !== 1 || items[0].properties?.['Flavour mix'] !== pending.mix) return 'changed';
    return 'found';
  };
  const makeAttempt = () => {
    const random = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now().toString(36)}-${Array.from(crypto.getRandomValues(new Uint32Array(3))).map(value => value.toString(36)).join('-')}`;
    return {id:random, signature:signature(), variantId:String(selectedPackage().id), mix:mixText(), status:'adding', createdAt:Date.now()};
  };
  const makeProperties = pending => {
    const properties = {'Flavour mix':pending.mix, _landing_page:config.landingId || 'lp-jeeroul-c', _jrc_attempt:pending.id};
    const params = new URLSearchParams(location.search);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key => {
      const value = params.get(key);
      if (value) properties[`_${key}`] = value.replace(/[\u0000-\u001F\u007F]/g, '').slice(0, 150);
    });
    return properties;
  };
  const goCheckout = () => {
    stage = 'redirecting'; navigating = true; render();
    const form = document.createElement('form');
    form.method = 'post'; form.action = cartUrl; form.hidden = true;
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = 'checkout'; input.value = '1';
    form.append(input); document.body.append(form);
    clearTimeout(navigationTimer);
    navigationTimer = setTimeout(() => {
      if (!navigating) return;
      navigating = false; busy = false; stage = ''; form.remove();
      showError(t(location.hostname.endsWith('.shopifypreview.com') ? 'preview_checkout' : 'checkout_stalled')); render();
    }, 12000);
    try { HTMLFormElement.prototype.submit.call(form); } catch { location.assign(checkoutUrl); }
  };
  const ensureMainBox = async () => {
    showError('');
    if (total() !== state.size) { showError(t('invalid_mix', {size:state.size})); return; }
    if (!stockConfirmed()) { showError(stockMessage(stockStates[state.size]) || t('stock_error')); return; }
    if (attempt) {
      let result;
      try { result = await reconcile(attempt); } catch { showError(t('uncertain')); return; }
      if (result === 'changed') { showError(t('changed_cart')); return; }
      if (result === 'found') {
        attempt.status = 'added'; persistAttempt();
        if (attempt.signature === signature()) { return true; }
        showError(t('changed_cart')); return;
      } else if (attempt.status !== 'added') {
        attempt.status = 'uncertain'; persistAttempt(); showError(t('uncertain_not_found')); return;
      }
    }
    attempt = makeAttempt(); persistAttempt();
    stage = 'adding'; render();
    try {
      const {response, data} = await request('cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:attempt.variantId, quantity:1, properties:makeProperties(attempt)}]})});
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) { attempt = null; persistAttempt(); showError(t('add_failed')); return; }
        throw new Error('uncertain_add');
      }
      const items = Array.isArray(data.items) ? data.items : [data];
      const added = items.find(item => item.properties?._jrc_attempt === attempt.id);
      if (!added || String(added.variant_id || added.id) !== attempt.variantId || added.quantity !== 1 || added.properties?.['Flavour mix'] !== attempt.mix) throw new Error('unconfirmed_add');
      attempt.status = 'added'; persistAttempt(); return true;
    } catch {
      attempt.status = 'uncertain'; persistAttempt();
      try {
        const result = await reconcile(attempt);
        if (result === 'found') { attempt.status = 'added'; persistAttempt(); return true; }
        showError(t(result === 'changed' ? 'changed_cart' : 'uncertain'));
      } catch { showError(t('uncertain')); }
    }
  };
  // The main-box attempt remains independent from the optional PWP transaction.
  const performCheckout = async () => {
    const pwp = window.JeeroulPwp;
    let pwpConfig = pwp?.config;
    if (!pwpConfig) { try { pwpConfig = JSON.parse(document.getElementById('jr-pwp-config')?.textContent || 'null'); } catch {} }
    const pwpActive = pwpConfig?.enabled === true && Date.now() >= Date.parse(pwpConfig.startsAt) && Date.now() <= Date.parse(pwpConfig.endsAt);
    if (pwpActive && pwpConfig?.previewOnly !== true && (typeof pwp?.beforeCheckout !== 'function' || typeof pwp?.preflightCheckout !== 'function')) {
      showError(String(config.locale || '').startsWith('zh') ? '加购功能尚未准备好，请刷新页面。' : 'The add-on feature is not ready. Please refresh this page.');
      return;
    }
    if (pwpConfig?.previewOnly === true) {
      const result = {ready:false,error:'preview',canSkip:true,message:String(config.locale || '').startsWith('zh') ? '这是优惠预览。优惠券尚未启用，不会加入加购商品。' : 'This is an offer preview. The voucher is not active and no add-on will be added.'};
      pwp.showCartError?.(result); showError(result.message); return;
    }
    // Pure validation precedes the main POST; an opted-in but incomplete pair cannot add a box.
    if (typeof pwp?.preflightCheckout === 'function') {
      const check = pwp.preflightCheckout({language:config.locale || 'en'});
      if (!check?.ready) { pwp.showCartError?.(check); showError(check?.message || (String(config.locale || '').startsWith('zh') ? '请先选满两片加购。' : 'Choose both add-on pieces first.')); return; }
    }
    if (!await ensureMainBox()) return;
    // Outside the main POST catch: a PWP failure must not mark the main box uncertain.
    if (typeof pwp?.beforeCheckout === 'function') {
      const result = await pwp.beforeCheckout({root:rootUrl, language:config.locale || 'en'});
      if (!result?.ready) {
        pwp.showCartError?.(result || {error:'cart',canSkip:false});
        showError(result?.message || (String(config.locale || '').startsWith('zh') ? '尚未确认加购，请检查购物车。' : 'The add-on has not been confirmed. Please review your cart.'));
        return;
      }
    }
    pwp?.markCheckoutStarted?.();
    goCheckout();
  };
  $('#checkout-box')?.addEventListener('click', event => {
    event.preventDefault();
    if (busy || checkoutPromise) return;
    if (!validDraft() || !draftMatchesState()) { showError(t('apply_first')); return; }
    busy = true; stage = 'adding'; render();
    checkoutPromise = performCheckout().catch(() => { showError(t('uncertain')); }).finally(() => {
      checkoutPromise = null;
      if (!navigating) { busy = false; stage = ''; render(); }
    });
  });
  window.addEventListener('pageshow', () => { clearTimeout(navigationTimer); busy = false; navigating = false; checkoutPromise = null; stage = ''; render(); });
  render();
  if (restoredDraft) openSummary(restoredDraft);
  else if ([12,20].some(size => ['sold_out','error'].includes(stockStates[size]))) refreshStock();
})();


(() => {
  if (!document.body.classList.contains('jeeroul-landing-c')) return;
  // Shopping prices enter the experience with the box builder, including on return visits.
  const build = document.getElementById('build');
  const shoppingBar = document.querySelector('.mobile-bar');
  let shoppingFrame = 0;
  const updateShoppingBar = () => {
    shoppingFrame = 0;
    const show = !!build && build.getBoundingClientRect().top <= innerHeight * 0.65;
    document.body.classList.toggle('c-mobile-shopping', show);
    if (shoppingBar) shoppingBar.hidden = !show;
  };
  const scheduleShoppingBar = () => {
    if (!shoppingFrame) shoppingFrame = requestAnimationFrame(updateShoppingBar);
  };
  updateShoppingBar();
  addEventListener('scroll', scheduleShoppingBar, {passive: true});
  addEventListener('resize', scheduleShoppingBar, {passive: true});
  addEventListener('pageshow', scheduleShoppingBar);
  addEventListener('load', scheduleShoppingBar, {once: true});
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleShoppingBar);
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const elements = [...document.querySelectorAll('.c-reveal')];
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('c-visible'); observer.unobserve(entry.target); }
    });
  }, {rootMargin: '0px 0px 70px 0px', threshold: 0.05});
  elements.forEach(element => {
    if (element.getBoundingClientRect().top < innerHeight) element.classList.add('c-visible');
    observer.observe(element);
  });
  document.body.classList.add('c-motion-ready');
})();


  } catch(e) { console.error(e); }
})();
})();
